import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { ClientInfoConfig, ClientStudy, FilesWithIdentifiers, NestingTypeValue, VariableLabelCode, configuration_data, ClientName, KeyValue, VariableLabelSublevelCode, LowBase } from 'src/app/common/models/configurations.model';
import { SnapshotSharedVariablesService } from '../Services/snapshot-shared-variables.service';
import { CONFIG_BUTTONS_NAMES, CONFIG_HEADERS_CONSTANTS, CONFIG_OTHER_NAMES, FOLDER_LIST, MESSAGE_TEXT } from '../../configuration/configuration/constants/configuration-constants';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { SnapshotService } from '../Services/snapshot.service'; // Replace './path/to/addSnapshotConfiguration' with the actual path to the addSnapshotConfiguration file
import { LoaderService } from '../../../common/services/loader.service';
import { CommonChartmoduleService } from '../Services/common-chartmodule.service';
import { Router } from '@angular/router';
import { AfterViewInit } from '@angular/core';
import { set } from 'lodash';
import { debounceTime, Subject, Subscription, takeUntil } from 'rxjs';
import { CheckboxSelectionModel } from 'src/app/common/constants/common-constants';
import { AlertMessageModel } from 'src/app/common/models/common.model';
import { AlertMessageService } from 'src/app/common/services/alert-message.service';
import { CustomsnapshotService } from '../Services/customsnapshot.service';

@Component({
  selector: 'app-moduleconfiguration',
  templateUrl: './module-configuration.component.html',
  styleUrls: ['./module-configuration.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModuleconfigurationComponent implements OnInit, OnChanges {
  // Track if the current study is Respondent Level
  isRespondentLevelFormat: boolean = false;

  @Input() id: number | undefined;
  @Input() currentSnapshotList: any;
  @Input() selectedSnapshotData: any | undefined;
  @Input() clientStudyData: any | undefined; // Receive data from parent to avoid duplicate API call
  @Output() isSubmitted = new EventEmitter<boolean>();
  @Output() alreadyExisting = new EventEmitter<boolean>();
  otherConstants = CONFIG_OTHER_NAMES;
  @ViewChild('snapshotInput') snapshotInput:
    | ElementRef<HTMLInputElement>
    | undefined;
      listOfFiles: FilesWithIdentifiers[] = [];
  entryPointsData: any = null;
  AudienceVariableList:any[]=[];
  aggregatedVariables: any = null;
  snapshotData: any = {};
  form: FormGroup;
    buttonNameConstants = CONFIG_BUTTONS_NAMES;
  defaultselectedWidget = '6 Widget Layout';
  selectedwidget: string = this.defaultselectedWidget;
  popUpTitle: string = "Error";
  private subscriptions: Subscription = new Subscription();
  protected destroy$: Subject<void> = new Subject<void>();
  isSubmit: boolean = true;
  // --- Loader override helpers (very small & page-scoped) ---------------------
  // We only set a CSS variable for the lifetime of this component so the
  // loader uses the explicit GIF while this page is active, then restore it.
  private _savedLoaderGifVar: string | null = null;
  // Use absolute app-root path to ensure correct resolution from anywhere
  private _explicitLoaderUrl = 'url("/assets/images/common/loader/Exp+_Loader_White.gif")';
  // -----------------------------------------------------------------------------
  selected_FolderName: string = this.otherConstants.FOLDER_SELECTED_DEFAULT_VAL;
    search_FileName: string = "";
      isClientTab: boolean = true;
  isStudyTab: boolean = false;
  isInsightsCacheTab: boolean = false;
  //Flags
  audienceComparision:any;
  selectedAudienceComparisons: any[] = [];
  showAudienceComparisonDropdown: boolean = false;
  audienceComparisonSearch: string = '';
  filteredAudienceComparision: any[] = [];
  
  // Total Sample
  totalSampleList: any[] = [];
  selectedTotalSample: any = null;
  showTotalSampleDropdown: boolean = false;
  totalSampleSearch: string = '';
  filteredTotalSample: any[] = [];

  // Brand Selection
  brandList: any[] = [];
  selectedBrand: any = null;
  showBrandDropdown: boolean = false;
  brandSearch: string = '';
  filteredBrandList: any[] = [];
  brandSelectionEnabled: boolean = false;

    /** folder name of the document */
  document_FolderName: string = "";
  /** File name of the document */
  document_FileName: string = "";
  showFiles:boolean=false;
    documentFilesList: FilesWithIdentifiers[] = [];
  selected_FileName: string = this.otherConstants.FILE_SELECTED_DEFAULT_VAL;
    search_FolderName: string = "";
      listOfFolders: string[] = [...FOLDER_LIST];
    showFolders: boolean = false;
  defaultAnswerBaseInput: boolean = true;
  answerBaseInput: boolean = this.defaultAnswerBaseInput;
  popUpMessage: any = '';
  errorheaderTitle: any = '';
  defaultStaticTextAreaFlag: Boolean = true;
  showStaticTextAreaFlag: Boolean = this.defaultStaticTextAreaFlag;
  defaultOutputConfig: string = 'user';
  outputConfig: string = this.defaultOutputConfig;
  defaultStickyorDefault: string = 'sticky';
  stickyDefaultSelected: string = this.defaultStickyorDefault;
  defaultResetSelectionFlag = true;
  resetSelectionFlag: Boolean = this.defaultResetSelectionFlag;
  showStudyNameDropdown: Boolean = false;
  statictext: string = '';
  data = this._configService.clientData;
  dataExistance: Boolean = this._configService.ifDataExists;
  snapCountNum: number = this.snapshotCount.snapshotCount;
  snapshotName: string = '';
  snapshotType: string = '';
  docFolderType: string = '';
  docFileType: string = '';
  studyName: string = '';
  numberOfWidget: number = 4;
  snapshotLayout: string = '';
  togglestudyName: Boolean = false;
  showSingleBrand: boolean = false;
  showMultiBrand: boolean = false;
  showMultiCategory: boolean = false;
  showMultiMarket: boolean = false;
  showAudienceSnapshot: boolean = false;
  audienceCohortType: string = 'single';
  audienceComparisonEnabled: boolean = false;
  totalSampleEnabled: boolean = false;
  
  // Entry Points and Dimensions collapse flags
  showEntryPointsSB: boolean = false;
  showDimensionsSB: boolean = false;
  showEntryPointsMB: boolean = false;
  showDimensionsMB: boolean = false;
  showEntryPointsMC: boolean = false;
  showDimensionsMC: boolean = false;
  showEntryPointsMM: boolean = false;
  showDimensionsMM: boolean = false;
  showEntryPointsAS: boolean = false;
  showDimensionsAS: boolean = false;
  showSubmitPopUp: boolean = false;
  showPopUp = false;
  showErrorPopUp = false;
  showDeletePopup = false;
  lastSelectedOption: any = null;
  lastSelectedType: string = '';
  // Track original cohort type for change detection
  originalAudienceCohortType: string = 'single';

  checkedList: any = [];
  snapshotNamesList: any = [];
  moduleConfigPropertiesDisplay = [];
  saveSelectionCheckedList: any = [];
  userManagementCheckedList: any = [];
  additionalCheckBoxCheckedList: any = [];
  customContentCheckedList: any = [];
  comparisionCheckedList: any = [];
  exportEntryPoints: any = [];
  exportDimensions: any = [];
  significanceTypeCheckedList: any = [];
  exportCheckedList: any = [];
  multipleConfidenceCheckedList: any = [];
  defaultConfidenceLevel: string = '';
  selectedConfidenceLevels: any[] = [];
  
  // Custom Base properties
  customBaseMetrics: string[] = [];
  orderedCustomBaseMetrics: string[] = [];
  filteredCustomBaseMetrics: string[] = [];
  showCustomBaseDropdown: boolean = false;
  selectedCustomBases: string[] = [];
  customBaseInput: boolean = false;
  customBaseSearchText: string = '';
  private hasLoadedSnapshotData: boolean = false; // Track if snapshot data has been loaded

  constructor(
    private fb: FormBuilder,
    private snapshotCount: SnapshotSharedVariablesService,
    public _configService: SnapshotService,
    private clientDetails: SnapshotSharedVariablesService,
    private snapshotDetails: SnapshotSharedVariablesService,
    private _loaderService: LoaderService,
    private commonchartservice: CommonChartmoduleService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private _alertService: AlertMessageService,
    private customSnapshotService: CustomsnapshotService,
  ) {
    this.form = new FormGroup({
      snapshotName: new FormControl(''),
      snapshotType: new FormControl(''),
      docFolderType: new FormControl(''),
      docFileType: new FormControl(''),
      newFileText: new FormControl(''),
      studyName: new FormControl(''),
      staticText: new FormControl(''),
      widgetTypeForm: new FormControl(''),
    });

  }

  async ngOnInit() {

    // Simpler: set the CSS variable to the explicit URL for the lifetime of this component
    // and restore the previous value in ngOnDestroy. Keep this minimal but safe.
    try {
      this._savedLoaderGifVar = getComputedStyle(document.documentElement).getPropertyValue('--loader-gif') || null;
      document.documentElement.style.setProperty('--loader-gif', this._explicitLoaderUrl);
    } catch (e) {
      // If DOM isn't available (SSR) or access fails, leave _savedLoaderGifVar as-is (null)
    }

    this.additionalCheckBoxSelection.forEach((item: any) => {
          item.selected = false;
    })

    this._loaderService.showLoader();

    // Reuse data from service if already loaded by parent component
    if (this._configService.clientData && this._configService.clientData.length > 0) {
      this.data = this._configService.clientData;
    } else {
      // Fallback: fetch if not available in service
      const res = await this._configService
        .getConfigurationByClientName(this.clientDetails.clientDetails.client_name)
        .toPromise()
        .then((c) => {
          this.data = JSON.parse(c.Data);
          this._configService.clientData = this.data;
        });
    }

    // Extract customBaseMetrics from the selected study
    if (this.clientDetails.clientDetails.selectedStudy) {
      const matchingStudy = this.data.find(
        (item: any) => item.configData?.study === this.clientDetails.clientDetails.selectedStudy
      );
      if (matchingStudy && matchingStudy.configData?.customBaseMetrics) {
        this.customBaseMetrics = matchingStudy.configData.customBaseMetrics;
      }
    }

    this.studyNames = [];
    this.snapshotDetails.studyNameDetails = [];


    for (let i = 0; i < this.data.length; i++) {

      if (
        this.data[i].configData.study != undefined &&
        this.data[i].configData.study != null &&
        this.data[i].configData.study != ''
      ) {
        this.snapshotDetails.studyNameDetails.push(
          this.data[i].configData.study
        );

      }
    }

    this.studyNames = this.snapshotDetails.studyNameDetails.map(
      (studyName: string, index: number) => {
        return { id: index, name: studyName, selected: false };
      }
    );

    this.form = this.fb.group({
      snapshotName: [''],
      snapshotType: [''],
      docFolderType: [''],
      docFileType: [''],
      newFileText: [''],
      studyName: [''],
      staticText: [''],
      widgetTypeForm: [''],
    });

    // this._configService.productSelected = this.snapshotData.product;
    // this._configService.templateSelected = this.snapshotData.product_type;

    this._configService.getModuleConfigProperties()
    .pipe(takeUntil(this.destroy$), debounceTime(100))
    .subscribe((data)=> {
      this._configService.moduleConfigPropertiesEnableDisable = JSON.parse(data.Data);
      if (this.clientDetails?.clientDetails?.study) {
        this.getStudyDetails();
      }
      this.CheckModuleConfigProperties();
    });


    // Only fetch audience snapshot options if selectedStudy is available
 
 const selectedStudyFromStorage = localStorage.getItem('selectedStudy');
const studyToSelect = selectedStudyFromStorage || this.studyNames[0]?.name;
 this.clientDetails.clientDetails.selectedStudy=studyToSelect;
  const matchingStudy = this.studyNames.find(study => study.name === studyToSelect);
  if (matchingStudy) {
    matchingStudy.selected = true;
  }
  // If there's a study from the upper tab, mark it as selected and set selectedStudy
     this.loadAudienceComparisonData();
    const inputElement = document.querySelector(
      '.snapshotName'
    ) as HTMLInputElement;
    if (this.selectedSnapshotData == undefined) {
      this.selectedSnapshotData = {
        clientName: this.clientDetails.clientDetails.client_name,
        snapshotName: this.clientDetails.clientDetails.study
      }
    }

    // this.GetClientExistingSnapshotData("Test folder creation","payel12-new","Single Brand");
    // Note: GetClientExistingSnapshotData is now called from ngOnChanges when clientStudyData is available
    if (this.selectedSnapshotData.snapshotName != '') {
      // If snapshot data is already loaded in the service, populate the form immediately
      if (this._configService.alreadySavedSnapshotData?.snapshot_name === this.selectedSnapshotData.snapshotName) {
        this.AddAlreadyExistingData();
        
      }
      if (inputElement != null) {
        inputElement.disabled = true;
        inputElement.classList.add('disabled');
      }
      else if (this._configService.afterRefreshShowModuleConfig) {
      
        // find the div with classname general_configuaration and click
        const snapshotConfigurationTabs = document.querySelector('.general_configuaration');
        if (snapshotConfigurationTabs) {
          this._configService.afterRefreshShowModuleConfig = false;
          //make display block for div with classname dropdown-container
          const dropdownContainer = document.querySelector('.dropdown-container');
          if (dropdownContainer) {
            (dropdownContainer as HTMLElement).style.display = 'flex';
          }

          (snapshotConfigurationTabs as HTMLElement).click();

        }
      }
    }



    // this.studyNames.forEach((study: any) => {
    //   study.selected = false;
    // });

    // const snapLayoutInput = document.querySelector(
    //   '.SnapshotFieldInputLayout'
    // ) as HTMLElement;
    // snapLayoutInput.innerHTML = this.selectedwidget;

    if (this.selectedSnapshotData.snapshotName == '') {
      this.clearAll();
      inputElement.classList.remove('disabled');
    }
    const clientNameArea = document.querySelector('.client-name-area');
    if (clientNameArea) {
      clientNameArea.textContent = this.clientDetails.clientDetails.client_name;
    }

  }

getUniqueVariableResponseCombinations(data: any[]): any[] {
  if (!Array.isArray(data) || data.length === 0) {
    return [];
  }

  const result: any[] = [];

  data.forEach((item: any) => {
    // Only process items where Audience_WidgetMapping_Variable is 'Audience'
    if (item.metric_group_snapshot !== 'Audience') {
      return;
    }

    const variableCode = item.variable_code;
    const responseCode = item.response_code;
    const isSnapshot = item.Is_snapshot;
    
    // Skip if either code is null, undefined, or empty, or if Is_snapshot is not true
    if (!variableCode || !responseCode || isSnapshot !== 1) {
      return;
    }

    result.push({
      variable_code: variableCode,
      response_code: responseCode,
      variable_label: item.data_variable_code || item.variable_label || '',
      is_selected: item.is_selected || false,
      Is_snapshot: isSnapshot,
      Audience_WidgetMapping_Variable: item.Audience_WidgetMapping_Variable
    });
  });

  return result;
}




UniqueBrandData(data: any[]): any[] {
  if (!Array.isArray(data) || data.length === 0) {
    return [];
  }

  const result: any[] = [];

  data.forEach((item: any) => {
    // Filter: Only process items where metric_group is 'brands' and is_snapshot is 1
    if (item.metric_group_snapshot?.toLowerCase() !== 'brands' || item.Is_snapshot !== 1) {
      return;
    }
    result.push({

      variable_label: item.variable_label || '',
      response_label: item.variable_label + '|' + item.response_label || '',
      metric_group: item.metric_group || '',
      is_snapshot: item.Is_snapshot,
      response_code: item.response_code || '',
      variable_code: item.data_variable_code || '',
    });
  });

  return result;
}


getUniqueAudienceModConf(audienceModConf: any[]): any[] {
  if (!Array.isArray(audienceModConf) || audienceModConf.length === 0) {
    return [];
  }

  // Create a map to store unique entries based on variable_code
  const uniqueMap = new Map<string, any>();

  audienceModConf.forEach((item: any) => {
    // Create a unique key using variable_code
    const key = item.variable_code;
    
    // Only add if this variable_code doesn't exist yet
    if (!uniqueMap.has(key)) {
      uniqueMap.set(key, {
        variable_label: item.variable_label || item.label || '',
        variable_code: item.data_variable_code || item.variable_code || '',
        config_name: item.Audience_ModConf || '',
        response_code: item.response_code || '',

        is_selected: false // Default selection state
      });
    }
  });

  // Convert map values back to array and sort by config_name in ascending order
  return Array.from(uniqueMap.values()).sort((a, b) => {
    const configA = (a.config_name || '').toLowerCase();
    const configB = (b.config_name || '').toLowerCase();
    return configA.localeCompare(configB);
  });
}




onAudienceComparisonChange(event: any) {
  this.audienceComparisonEnabled = event.target.checked;
  if (!this.audienceComparisonEnabled) {
    this.selectedAudienceComparisons = [];
    this.showAudienceComparisonDropdown = false;
  } else {
    // Initialize filtered list when enabling
    this.filteredAudienceComparision = this.audienceComparision ? [...this.audienceComparision] : [];
  }
  this.cdr.detectChanges();
}

onTotalSampleChange(event: any) {
  this.totalSampleEnabled = event.target.checked;
  if (this.totalSampleEnabled) {
    // Automatically show dropdown when enabled
   
    this.filteredTotalSample = this.totalSampleList ? [...this.totalSampleList] : [];
    this.totalSampleSearch = '';
    this.sortTotalSampleList();
  } else {
    this.showTotalSampleDropdown = false;
    // Clear the selected item when unchecking
    this.selectedTotalSample = null;
  }
  this.cdr.detectChanges();
}

onCohortTypeChange(type: string) {
  this.audienceCohortType = type;
  this.customSnapshotService.audienceCohortType = type;
  this._configService.audienceCohortType = type;
  
  this.cdr.detectChanges();
}

toggleAudienceComparisonDropdown() {
  // if (!this.audienceComparisonEnabled) return;
  this.showAudienceComparisonDropdown = !this.showAudienceComparisonDropdown;
   if (this.showAudienceComparisonDropdown) {
        
        this.audienceComparisonEnabled = true;
    }
  
  if (this.showAudienceComparisonDropdown) {
    this.filteredAudienceComparision = this.audienceComparision ? [...this.audienceComparision] : [];
    this.audienceComparisonSearch = '';
    // Sort when opening the dropdown
    this.sortAudienceComparisonList();
  }
  this.cdr.detectChanges();
}

onAudienceComparisonSelect(item: any, event: any) {
  // if (event.target.checked) {
  //   if (!this.selectedAudienceComparisons.find(x => 
  //     x.variable_code === item.variable_code)) {
  //     this.selectedAudienceComparisons.push({
  //       variable_label: item.variable_label,
  //       variable_code: item.data_variable_code || item.variable_code,
  //       response_code: item.response_code || '',
  //       config_name: item.config_name,
  //       is_selected: true
  //     });
  //   }
  // } else {
  //   this.selectedAudienceComparisons = this.selectedAudienceComparisons.filter(x => 
  //     x.data_variable_code !== item.variable_code
  //   );
  // }
  // // Don't re-sort immediately - sorting will happen when dropdown is reopened
  // this.cdr.detectChanges();
  const varCode = item.data_variable_code || item.variable_code;

    if (event.target.checked) {
      // add only if not already present (compare using normalized varCode)
      if (!this.selectedAudienceComparisons.find(x => x.variable_code === varCode)) {
        this.selectedAudienceComparisons.push({
          variable_label: item.variable_label,
          variable_code: varCode,
          response_code: item.response_code || '',
          config_name: item.config_name,
          is_selected: true
        });
      }
    } else {
      // remove by matching the same normalized property
      this.selectedAudienceComparisons = this.selectedAudienceComparisons.filter(x => x.variable_code !== varCode);
    }

    // Update enabled flag based on whether any items remain selected
    this.audienceComparisonEnabled = this.selectedAudienceComparisons.length > 0;
    // Don't re-sort immediately - sorting will happen when dropdown is reopened
    this.cdr.detectChanges();
}

isAudienceComparisonSelected(item: any): boolean {
   return this.selectedAudienceComparisons.some(x => 
    x.variable_code === (item.data_variable_code || item.variable_code)
  );
}

sortAudienceComparisonList() {
  this.filteredAudienceComparision.sort((a, b) => {
    const aSelected = this.isAudienceComparisonSelected(a);
    const bSelected = this.isAudienceComparisonSelected(b);
    
    // Selected items come first
    if (aSelected && !bSelected) return -1;
    if (!aSelected && bSelected) return 1;
    
    // If both selected or both not selected, sort by config_name in ascending order
    const configA = (a.config_name || '').toLowerCase();
    const configB = (b.config_name || '').toLowerCase();
    return configA.localeCompare(configB);
  });
}

onAudienceComparisonSearchChange() {
  if (!this.audienceComparisonSearch.trim()) {
    this.filteredAudienceComparision = [...this.audienceComparision];
  } else {
    const searchTerm = this.audienceComparisonSearch.toLowerCase();
    this.filteredAudienceComparision = this.audienceComparision.filter((item: any) =>
      item.variable_label?.toLowerCase().includes(searchTerm) ||
      item.config_name?.toLowerCase().includes(searchTerm)
    );
  }
  // Sort to show selected items first
  this.sortAudienceComparisonList();
  this.cdr.detectChanges();
}

areAllAudienceComparisonsSelected(): boolean {
  if (!this.filteredAudienceComparision || this.filteredAudienceComparision.length === 0) {
    return false;
  }
  return this.filteredAudienceComparision.every((item: any) => 
    this.isAudienceComparisonSelected(item)
  );
}

onSelectAllAudienceComparison(event: any) {
  const isChecked = event.target.checked;
  
  if (isChecked) {
    // Select all filtered items
    this.filteredAudienceComparision.forEach((item: any) => {
      if (!this.isAudienceComparisonSelected(item)) {
        this.selectedAudienceComparisons.push({
          variable_label: item.variable_label,
          variable_code: item.data_variable_code || item.variable_code,
          config_name: item.config_name,
          response_code: item.response_code || '',
          is_selected: true
        });
      }
    });
  } else {
    // Deselect all filtered items
   this.filteredAudienceComparision.forEach((item: any) => {
      const varCode = item.data_variable_code || item.variable_code; // ✅ Fix here
      this.selectedAudienceComparisons = this.selectedAudienceComparisons.filter(x => 
        x.variable_code !== varCode // ✅ Compare with correct property
      );
    });
  }
  
  // Sort to show selected items first
  this.sortAudienceComparisonList();
  // Update enabled flag after select-all/deselect-all
  this.audienceComparisonEnabled = this.selectedAudienceComparisons.length > 0;
  this.cdr.detectChanges();
}

resetAudienceComparisonSelection() {
  this.selectedAudienceComparisons = [];
  this.sortAudienceComparisonList();
    // No selections -> disable audience comparison
    this.audienceComparisonEnabled = false;
    this.cdr.detectChanges();
}

clearAudienceComparisonSearch() {
  this.audienceComparisonSearch = '';
  this.filteredAudienceComparision = [...this.audienceComparision];
  this.cdr.detectChanges();
}

// Total Sample Methods
toggleTotalSampleDropdown() {
  // Only toggle dropdown if it's already enabled
  // if (!this.totalSampleEnabled) return;
  
  this.showTotalSampleDropdown = !this.showTotalSampleDropdown;
  
  
  if (this.showTotalSampleDropdown) {
    this.filteredTotalSample = this.totalSampleList ? [...this.totalSampleList] : [];
    this.totalSampleSearch = '';
    this.sortTotalSampleList();
  }
  this.cdr.detectChanges();
}

onTotalSampleSelect(item: any, event: any) {
  if (event.target.checked) {
    this.selectedTotalSample = {
      variable_label: item.variable_label,
      variable_code: item.variable_code,
      response_code: item.response_code || '',
      config_name: item.config_name,
      is_selected: true
    };
  }
 // this.sortTotalSampleList();
  // When a selection exists, enable the main total sample checkbox
  this.totalSampleEnabled = !!this.selectedTotalSample;
  this.cdr.detectChanges();
}

isTotalSampleSelected(item: any): boolean {
  return this.selectedTotalSample && 
         this.selectedTotalSample.variable_code === item.variable_code;
}

onTotalSampleSearchChange() {
  if (!this.totalSampleSearch.trim()) {
    this.filteredTotalSample = [...this.totalSampleList];
  } else {
    const searchTerm = this.totalSampleSearch.toLowerCase();
    this.filteredTotalSample = this.totalSampleList.filter((item: any) =>
      item.variable_label?.toLowerCase().includes(searchTerm) ||
      item.config_name?.toLowerCase().includes(searchTerm)
    );
  }
  this.sortTotalSampleList();
  this.cdr.detectChanges();
}

clearTotalSampleSearch() {
  this.totalSampleSearch = '';
  this.filteredTotalSample = [...this.totalSampleList];
  this.sortTotalSampleList();
  this.cdr.detectChanges();
}

resetTotalSampleSelection() {
  this.selectedTotalSample = null;
  //this.sortTotalSampleList();
    // No selection -> disable total sample
    this.totalSampleEnabled = false;
    this.cdr.detectChanges();
}

sortTotalSampleList() {
  this.filteredTotalSample.sort((a, b) => {
    const aSelected = this.isTotalSampleSelected(a);
    const bSelected = this.isTotalSampleSelected(b);
    
    // Selected item comes first
    if (aSelected && !bSelected) return -1;
    if (!aSelected && bSelected) return 1;
    
    // If both selected or both not sorted, maintain original order
    return 0;
  });
}

// Brand Selection Methods
onBrandChange(event: any) {
  this.brandSelectionEnabled = event.target.checked;
  if (this.brandSelectionEnabled) {
    // Automatically show dropdown when enabled
    this.filteredBrandList = this.brandList ? [...this.brandList] : [];
    this.brandSearch = '';
    this.sortBrandList();
    // Auto-select first brand if no brand is selected
    if (!this.selectedBrand && this.brandList.length > 0) {
      this.selectedBrand = {
        variable_label: this.brandList[0].variable_label,
        response_label: this.brandList[0].response_label,
        metric_group: this.brandList[0].metric_group,
        is_snapshot: this.brandList[0].is_snapshot,
        is_selected: true
      };
    }
  } else {
    this.showBrandDropdown = false;
    // Clear the selected brand when unchecking
    this.selectedBrand = null;
  }
  this.cdr.detectChanges();
}

toggleBrandDropdown() {
  this.showBrandDropdown = !this.showBrandDropdown;
  
  if (this.showBrandDropdown) {
    this.filteredBrandList = this.brandList ? [...this.brandList] : [];
    this.brandSearch = '';
    this.sortBrandList();
  }
  this.cdr.detectChanges();
}

onBrandSelect(item: any, event: any) {
  if (event.target.checked) {
    this.selectedBrand = {
      variable_label: item.variable_label,
      response_label: item.response_label,
      metric_group: item.metric_group,
      is_snapshot: item.is_snapshot,
      is_selected: true,
      config_name:  item.response_label || '',
    };
  }
  this.cdr.detectChanges();
}

isBrandSelected(item: any): boolean {
  return this.selectedBrand && 
         this.selectedBrand.response_label === item.response_label;
}

onBrandSearchChange() {
  if (!this.brandSearch.trim()) {
    this.filteredBrandList = [...this.brandList];
  } else {
    const searchTerm = this.brandSearch.toLowerCase();
    this.filteredBrandList = this.brandList.filter((item: any) =>
      item.variable_label?.toLowerCase().includes(searchTerm) ||
      item.response_label?.toLowerCase().includes(searchTerm)
    );
  }
  this.sortBrandList();
  this.cdr.detectChanges();
}

clearBrandSearch() {
  this.brandSearch = '';
  this.filteredBrandList = [...this.brandList];
  this.sortBrandList();
  this.cdr.detectChanges();
}

resetBrandSelection() {
  // Reset to first brand if list exists
  if (this.brandList.length > 0) {
    this.selectedBrand = {
      variable_label: this.brandList[0].variable_label,
      response_label: this.brandList[0].response_label,
      metric_group: this.brandList[0].metric_group,
      is_snapshot: this.brandList[0].is_snapshot,
      is_selected: true
    };
  } else {
    this.selectedBrand = null;
  }
  this.cdr.detectChanges();
}

sortBrandList() {
  this.filteredBrandList.sort((a, b) => {
    const aSelected = this.isBrandSelected(a);
    const bSelected = this.isBrandSelected(b);
    
    // Selected item comes first
    if (aSelected && !bSelected) return -1;
    if (!aSelected && bSelected) return 1;
    
    // If both selected or both not selected, maintain original order
    return 0;
  });
}

// Toggle methods for Entry Points and Dimensions
toggleEntryPointsSB() {
  this.showEntryPointsSB = !this.showEntryPointsSB;
}

toggleDimensionsSB() {
  this.showDimensionsSB = !this.showDimensionsSB;
}

toggleEntryPointsMB() {
  this.showEntryPointsMB = !this.showEntryPointsMB;
}

toggleDimensionsMB() {
  this.showDimensionsMB = !this.showDimensionsMB;
}

toggleEntryPointsMC() {
  this.showEntryPointsMC = !this.showEntryPointsMC;
}

toggleDimensionsMC() {
  this.showDimensionsMC = !this.showDimensionsMC;
}

toggleEntryPointsMM() {
  this.showEntryPointsMM = !this.showEntryPointsMM;
}

toggleDimensionsMM() {
  this.showDimensionsMM = !this.showDimensionsMM;
}

toggleEntryPointsAS() {
  this.showEntryPointsAS = !this.showEntryPointsAS;
}

toggleDimensionsAS() {
  this.showDimensionsAS = !this.showDimensionsAS;
}

// Helper methods to check if arrays have valid data
hasValidEntryPoints(entryPoints: any[]): boolean {
  return entryPoints && entryPoints.length > 0 && entryPoints.some(ep => ep.variable_code && ep.variable_code.trim() !== '');
}

hasValidDimensions(dimensions: any[]): boolean {
  return dimensions && dimensions.length > 0 && dimensions.some(dim => dim.variable_code && dim.variable_code.trim() !== '');
}

  async ngOnChanges(changes: SimpleChanges) {

    //if (changes.id) {
    // The id has changed. Re-initialize the form here.
      this.form.reset();
    //}
    
    // Reset flag if selected snapshot has changed
    if (changes['selectedSnapshotData'] && changes['selectedSnapshotData'].currentValue !== changes['selectedSnapshotData'].previousValue) {
      this.hasLoadedSnapshotData = false;
    }
    
    // Check if clientStudyData input has changed and data is now available
    if (changes['clientStudyData'] && this.clientStudyData && this.selectedSnapshotData?.snapshotName) {
      await this.GetClientExistingSnapshotData(
        this.selectedSnapshotData.clientName,
        this.selectedSnapshotData.snapshotName
      );
    }
    
    if(this.clientDetails.clientDetails.selectedStudy!=''){
//   const audience = await this._configService
//     .getAudienceSnapshotOptions(this.clientDetails.clientDetails.client_name, this.clientDetails.clientDetails.selectedStudy)
//     .toPromise()
//     .then((c) => {
//       // Check if c.Data is not empty before processing
//       if (!c.Data || c.Data.trim() === '' || c.Data === '[]' || c.Data === '{}') {
        
//         return;
//       }
      
//       this.data = JSON.parse(c.Data);
   
//       this._configService.clientData = this.data;
//  const uniqueData = this.getUniqueVariableResponseCombinations(this.data);
//       // Extract Audience_ModConf from all objects in the array
//       this.AudienceVariableList=uniqueData;
//     this.customSnapshotService.uniqueAudienceData = uniqueData;

//     const brandData = this.UniqueBrandData(this.data);
// this.customSnapshotService.uniqueBrandData = brandData;
//       if (this.data && Array.isArray(this.data) && this.data.length > 0) {
//         const allAudienceModConf: any[] = [];
        
//         // Loop through each object and extract Audience_ModConf
//         this.data.forEach((item: any) => {
//           if (item.Audience_ModConf) {
//             // Add all items from this object's Audience_ModConf to the combined array
//             allAudienceModConf.push(item);
//           }
//         });
        
      
//         // Get unique audience module configuration with variable codes and response codes
//         if (allAudienceModConf.length > 0) {
//           const uniqueAudienceModConf = this.getUniqueAudienceModConf(allAudienceModConf);
        
//           this.audienceComparision = uniqueAudienceModConf;
//           this.filteredAudienceComparision = uniqueAudienceModConf;
         
//           // Initialize Total Sample list with the same data
//           this.totalSampleList = uniqueAudienceModConf;
//           this.filteredTotalSample = uniqueAudienceModConf;
          
//           // Restore previously selected items if they exist
//           this.restoreAudienceSelections();
//         }
//       }
//     });
  }
    // this.snapshotName = '';
    // this.snapshotType = '';
    // this.studyName = '';
    this.numberOfWidget = 4;
    // this.snapshotLayout = '';
  }

  snapshotTypes = [
    { name: 'Brand Snap' },
    { name: 'Category Snap' },
    { name: 'Dummy Snap' },
  ];
  //delete
  docRepFolderTypes = [
    { name: 'Folder 1' },
    { name: 'Folder 2' },
  ];
  docRepFileTypes = [
    { name: 'File 1' },
    { name: 'File 2' },
  ];
  //delete end
  studyNames = [
    { id: 0, name: 'Study 1', selected: false },
    { id: 1, name: 'Study 2', selected: false },
    { id: 2, name: 'Dummy Study', selected: false },
  ];
  numberOfWidgets = [
    { name: 4 },
    { name: 5 },
    { name: 6 },
    { name: 7 },
    { name: 8 },
    { name: 9 },
    { name: 10 },
    { name: 11 },
    { name: 12 },
    { name: 13 },
    { name: 14 },
    { name: 15 },
    { name: 16 },
    { name: 17 },
    { name: 18 },
    { name: 19 },
    { name: 20 },
    { name: 21 },
    { name: 22 },
    { name: 23 },
    { name: 24 },
  ];

  entryPointsSB = [
    { variable_label: '', is_selected: false, variable_code: '' },
  ];

  dimensionsSB = [
    { variable_label: '', is_selected: false, variable_code: '' },
  ];

  entryPointsMB = [
    { variable_label: '', is_selected: false, variable_code: '' },
  ];

  dimensionsMB = [
    { variable_label: '', is_selected: false, variable_code: '' },
  ];
  entryPointsMC = [
    { variable_label: '', is_selected: false, variable_code: '' },
  ];

  dimensionsMC = [
    { variable_label: '', is_selected: false, variable_code: '' },
  ];
  entryPointsMM = [
    { variable_label: '', is_selected: false, variable_code: '' },
  ];

  dimensionsMM = [
    { variable_label: '', is_selected: false, variable_code: '' },
  ];
   entryPointsAS = [
    { variable_label: '', is_selected: false, variable_code: '' },
  ];
   dimensionsAS = [
    { variable_label: '', is_selected: false, variable_code: '' },
  ];
  


  comparisonPoints = [
    { id: 1, selected: false, name: 'Previous Year', value: 'previousYear' },
    {
      id: 2,
      selected: false,
      name: 'Previous Period',
      value: 'previousPeriod',
    },
    { id: 3, selected: false, name: 'Pairwise', value: 'pairWise' },
    { id: 3, selected: false, name: 'Reference', value: 'reference' },
  ];

  saveSelection = [
    { id: 1, selected: false, name: 'Save/Load', value: 'Save/Load' },
    { id: 2, selected: false, name: 'Global Default Selection', value: 'GlobalDefaultSelection' },
  ];

  outputconfiguration = [
    { id: 1, selected: true, name: 'Admin Defined', value: 'admin' },
  ];

  stickyDefaultSelection = [
    { id: 1, selected: true, name: 'Sticky', value: 'sticky' },
    { id: 2, selected: false, name: 'Default', value: 'default' },
  ];

  userManagementSelection = [
    { id: 1, selected: false, name: 'Entry Point', value: 'entryPoint' },
    { id: 2, selected: false, name: 'Dimension', value: 'dimension' },
  ];

  significance = [
    { id: 1, selected: false, name: 'Z Test', value: 'zTest' },
    { id: 2, selected: false, name: 'Test 2', value: 'test2' },
    { id: 3, selected: false, name: 'Test 3', value: 'test3' },
  ];

  multipleConfidence = [
    { id: 1, selected: false, name: '90%', value: '90%' },
    { id: 2, selected: false, name: '95%', value: '95%' },
    { id: 3, selected: false, name: '98%', value: '98%' },
    { id: 4, selected: false, name: '99%', value: '99%' },
  ];

  customContentSelection = [
    { id: 1, selected: false, name: 'Custom Percentage', value: 'customGroups' },
    { id: 2, selected: false, name: 'Custom Mean', value: 'customCalculations' },
    { id: 3, selected: false, name: 'Custom Reports', value: 'customReports' },
  ];

  export = [
    { id: 1, selected: false, name: 'Editable PPT', value: 'exportPPT' },
    {
      id: 2,
      selected: false,
      name: 'Non-Editable PPT',
      value: 'nonEditablePPT',
    },
    { id: 3, selected: false, name: 'Excel Export', value: 'excelExport' },
  ];

  additionalCheckBoxSelection = CheckboxSelectionModel.additionalCheckBoxSelection;

  reset = [
    { id: 1, selected: this.resetSelectionFlag, name: 'Yes', value: 'yes' },
    { id: 2, selected: !this.resetSelectionFlag, name: 'No', value: 'no' },
  ];

  toggleAnswerBase() {
    this.answerBaseInput = !this.answerBaseInput;
  }

  searchBoxClick(event: Event) {
    event.stopPropagation();
  }

  toggleCustomBaseDropdown() {
    this.showCustomBaseDropdown = !this.showCustomBaseDropdown;

    if (this.clientDetails.clientDetails.selectedStudy) {
      const matchingStudy = this.data.find(
        (item: any) => item.configData?.study === this.clientDetails.clientDetails.selectedStudy
      );
      if (matchingStudy && matchingStudy.configData?.customBaseMetrics) {
        this.customBaseMetrics = matchingStudy.configData.customBaseMetrics;
      }
    }

    if (this.showCustomBaseDropdown) {
      // Reorder ONLY when dropdown is opened
      const selected = this.selectedCustomBases.filter(m =>
        this.customBaseMetrics.includes(m)
      );
      const unselected = this.customBaseMetrics.filter(m =>
        !this.selectedCustomBases.includes(m)
      );
      this.orderedCustomBaseMetrics = [...selected, ...unselected];

      // Reset search each time dropdown opens
      this.customBaseSearchText = "";
      this.filteredCustomBaseMetrics = [...this.orderedCustomBaseMetrics];
    }
  }

  onCustomBaseSearchChange() {
    const term = this.customBaseSearchText.toLowerCase();
    this.filteredCustomBaseMetrics = this.orderedCustomBaseMetrics.filter(m =>
      m.toLowerCase().includes(term)
    );
  }

  onCustomBaseSelect(metric: string, event: any) {
    if (event.target.checked) {
      if (!this.selectedCustomBases.includes(metric)) {
        this.selectedCustomBases.push(metric);
      }
    } else {
      const index = this.selectedCustomBases.indexOf(metric);
      if (index > -1) {
        this.selectedCustomBases.splice(index, 1);
      }
    }
    this.customBaseInput = this.selectedCustomBases.length > 0;
  }

  clearAllCustomBaseSelections(event: Event) {
    event.stopPropagation();
    this.selectedCustomBases = [];
    this.customBaseInput = false;
  }

  isCustomBaseSelected(metric: string): boolean {
    return this.selectedCustomBases.includes(metric);
  }

  onCustomBaseChange(event: Event) {
    event.stopPropagation();
    const checked = (event.target as HTMLInputElement).checked;
    this.customBaseInput = checked;
    if(!this.customBaseInput){
      this.selectedCustomBases = [];
    }
  }

  onSelectAllCustomBase(event: any) {
    if (event.target.checked) {
      // Select all metrics
      this.selectedCustomBases = [...this.customBaseMetrics];
      this.customBaseInput = true;
    } else {
      // Deselect all metrics
      this.selectedCustomBases = [];
      this.customBaseInput = false;
    }
  }

  areAllCustomBasesSelected(): boolean {
    return this.customBaseMetrics.length > 0 && 
           this.selectedCustomBases.length === this.customBaseMetrics.length;
  }

  onStaticTextChanged(event: any) {
    // Capture the value of the textarea and store it in the staticText variable
    this.statictext = event.target.value;
  }

  numberOfWidgetsCLick(event: any) {
    this.numberOfWidget = Number(event.target.value);
  }


  CheckModuleConfigProperties() {
    let dataAll = this._configService.moduleConfigPropertiesEnableDisable;

    let productName = this._configService.productSelected;
    let templateName = this._configService.templateSelected;
    if (productName == "Standard")
      this.moduleConfigPropertiesDisplay = dataAll.filter((item: any) => {
        if (item.Product === productName && item.Template === templateName && item.Template !== "NA")
          return item;
      });
    else
      this.moduleConfigPropertiesDisplay = dataAll.filter((item: any) => {
        if (item.Product === productName)
          return item;
      });
    this.cdr.detectChanges();



    if (this.moduleConfigPropertiesDisplay.length != 0)
      this.CheckEnableDisableForFields();
  }

  CheckEnableDisableForFields() {

    if (this.moduleConfigPropertiesDisplay[0] != undefined) {
      Object.entries(this.moduleConfigPropertiesDisplay[0]).forEach(([key, value]) => {
        const divElement = document.getElementById("SnapshotFields" + key);
        let values = value as string;
        if (divElement && values.toLowerCase() == "na") {
          divElement.classList.add("disabled");

          switch (key) {
            case "Sticky_Default_selection":
              {
                this.stickyDefaultSelection = [
                  { id: 1, selected: false, name: 'Sticky', value: 'sticky' },
                  { id: 2, selected: false, name: 'Default', value: 'default' },
                ];
                this.defaultStickyorDefault = "";
                this.stickyDefaultSelected = "";
              }
              break;
            case "Static_Text":
              this.defaultStaticTextAreaFlag = false;
              break;
            case "Reset_Selection":
              // this.defaultResetSelectionFlag = true;
              // this.resetSelectionFlag = true;
              break;
            case "Output_Configuration":
              this.outputconfiguration = [
                { id: 1, selected: false, name: 'Admin Defined', value: 'admin' },
                { id: 2, selected: false, name: 'User Defined', value: 'user' },
              ];
              break;
            default:
              // Code for other keys
              break;
          }
        }
        else if (divElement) {
          divElement.classList.remove("disabled");
        }
        if (values != null) {
          if (values.toLowerCase() != "all" && values.toLowerCase() != "na") {
            switch (key) {
              case "Comparison_Points":
                let CP: any[] = [];
                let valuesAll = values.split(", ");
                valuesAll.forEach(a => {
                  this.comparisonPoints.forEach((element: any) => {
                    if (element.name == a)
                      CP.push(element)
                  });
                });
                this.comparisonPoints = CP;
                break;
              case "Export":
                this.export = [];
                let exportValuesAll = values.split(", ");
                exportValuesAll.forEach(a => { this.export.push({ id: 1, selected: false, name: a, value: a }) });
                break;
              case "Filter_Function":

                break;
              case "Multiple_Confidence_Levels":
                this.multipleConfidence = [];
                let multipleConfidenceValuesAll = values.split(", ");
                multipleConfidenceValuesAll.forEach(a => { this.multipleConfidence.push({ id: 1, selected: false, name: a, value: a }) });
                break;
              case "Output_Configuration":
                const index = this.outputconfiguration.findIndex(item => item.name === values);
                this.outputconfiguration = [];
                this.outputconfiguration.push({ id: index + 1, selected: true, name: values, value: values.split(" ")[0].toLowerCase() });

                break;
              case "Reset_Selection":
                {
                  const indexReset = this.reset.findIndex(item => item.name === values);
                  this.reset = [];
                  this.reset.push({ id: indexReset + 1, selected: true, name: values, value: values });

                  break;
                }
              case "Sticky_Default_selection":
                const indexSD = this.stickyDefaultSelection.findIndex(item => item.name === values);
                this.stickyDefaultSelection = [];
                this.stickyDefaultSelection.push({ id: indexSD + 1, selected: true, name: values, value: values });
                break;
              case "Types_of_Significance":
                this.significance = [];
                let significanceValuesAll = values.split(", ");
                significanceValuesAll.forEach(a => { this.significance.push({ id: 1, selected: false, name: a, value: a }) });
                break;

              default:
                // Code for other keys
                break;
            }
          }
        }
      });
    }
    setTimeout(() => {
      this._loaderService.hideLoader()
    }, 1000);
  }

  async GetClientExistingSnapshotData(
    clientCode: string,
    snapshotName: string
  ) {
    // Prevent duplicate calls - if we've already loaded this snapshot, skip
    if (this.hasLoadedSnapshotData) {
      return;
    }
    
    // Check if data is already provided from parent component
    if (this.clientStudyData && this.clientStudyData.body && this.clientStudyData.body.Data) {
      this._configService.alreadySavedSnapshotData = this.clientStudyData.body.Data ? JSON.parse(this.clientStudyData.body.Data) : this.clientStudyData.body.Data;
      if (
        this._configService.alreadySavedSnapshotData != null &&
        this._configService.alreadySavedSnapshotData != undefined &&
        this._configService.alreadySavedSnapshotData != ''
      ) {
        this.snapshotData = this._configService.alreadySavedSnapshotData;
        const d = this.snapshotData?.decimal_point_configuration;
        if (d) {
          this._configService.decimalPointConfig = {
            tabular: d.tabular ?? 'chart',
            charts: d.charts ?? 'chart',
            excel: d.excel ?? 'chart',
            ppt: d.ppt ?? 'chart'
          };
        }
        this.documentFilesList = this.snapshotData.documents || [];
        if (this.snapshotData != undefined && this.snapshotData != null) {
          this.dataExistance = true;
          this._configService.clientSnapshotSelectedData = this.snapshotData;
          this.AddAlreadyExistingData();
          this.hasLoadedSnapshotData = true; // Mark as loaded
        } else {
          this.dataExistance = false;
        }
      } else {
        this.dataExistance = false;
      }
      this._configService.ifDataExists = this.dataExistance;
      return;
    }
    
    // Fallback to API call if data is not provided
    this.subscriptions.add(
      this._configService
        .getClientStudyData({
          client_code: clientCode,
          snapshot_name: snapshotName,
        })
        .subscribe(async (b) => {
          this._configService.alreadySavedSnapshotData = b.body.Data ? JSON.parse(b.body.Data) : b.body.Data;
          if (
            this._configService.alreadySavedSnapshotData != null &&
            this._configService.alreadySavedSnapshotData != undefined &&
            this._configService.alreadySavedSnapshotData != ''
          ) {
            this.snapshotData = this._configService.alreadySavedSnapshotData;
            const d = this.snapshotData?.decimal_point_configuration;
            if (d) {
              this._configService.decimalPointConfig = {
                tabular: d.tabular ?? 'chart',
                charts: d.charts ?? 'chart',
                excel: d.excel ?? 'chart',
                ppt: d.ppt ?? 'chart'
              };
            }
            this.documentFilesList = this.snapshotData.documents || [];
            if (this.snapshotData != undefined && this.snapshotData != null) {
              this.dataExistance = true;
              this._configService.clientSnapshotSelectedData = this.snapshotData;

              //await this.UpdateProductAndTemplate();

              this.AddAlreadyExistingData();
              this.hasLoadedSnapshotData = true; // Mark as loaded

            } else {
              this.dataExistance = false;
            }
          } else {
            this.dataExistance = false;
          }
          this._configService.ifDataExists = this.dataExistance;
        }));
  }

  UpdateProductAndTemplate() {
    this._configService.productSelected = this.snapshotData.product;
    this._configService.templateSelected = this.snapshotData.product_type;
    this.CheckModuleConfigProperties();
  }

  showWidgetLayout() {
    this.errorheaderTitle = 'WidgetLayout';
    this.showPopUp = true;
    this.showErrorPopUp = false;
  }

  receiveLayoutWidget(message: string) {
    this.selectedwidget = message;
    const snapLayoutInput = document.querySelector(
      '.SnapshotFieldInputLayout'
    ) as HTMLElement;
    snapLayoutInput.innerHTML = this.selectedwidget;
  }

  onCloseIconClick(closePopUp: string): void {
    if (closePopUp == 'false') {
      this.showPopUp = false;
      this.errorheaderTitle = '';
      this.showErrorPopUp = false;
      if (!this.showErrorPopUp && this.popUpTitle != "Error") {
        let data: {
          client_name: string;
          study: string;
          configdata: any;
        } = {
          client_name: this.clientDetails.clientDetails.client_name,
          study: this.clientDetails.clientDetails.study,
          configdata: this.clientDetails.clientDetails.configdata,
        };
        setTimeout(() => {
          this.router
            .navigateByUrl('Snapshot/snapshotpreview', {
              skipLocationChange: true,
            })
            .then(() => {
              this.router.navigateByUrl('Snapshot/configuaration', {
                state: data,
              });
            });
        }, 100);
      }
    }
  }

  addSnapshotTab() {
    const element = document.querySelector('.snapshot-button-area'); // Replace '.snapshot-create-btn' with the selector of your target element

    const inputElement = document.getElementById(
      'SnapshotNameFieldInput' + this.snapCountNum
    ) as HTMLInputElement;
    if (inputElement) {
      this.snapshotName = inputElement.value;
    }

    if (element) {
      const snapshotButton = document.createElement('div');
      snapshotButton.setAttribute('ngModel', this.snapCountNum.toString());

      snapshotButton.className = 'snapshot-create-button';
      snapshotButton.title = this.snapshotName;
      snapshotButton.id = 'snapshot' + this.snapCountNum;
      snapshotButton.style.cssText =
        'color: white;background: linear-gradient(90deg, #8600CD 0%, #1110EB 100%);border: 1px solid #8029B6; border-radius: 0.375rem; display: flex; align-items: center; justify-content: space-evenly; cursor: pointer; width: 8.5rem; height: 100%; margin-right: 1rem;';

      snapshotButton.addEventListener('click', () => {
        const clickedElementId = snapshotButton.id;
        const snapshotId = clickedElementId.split('snapshot')[1];
        this.snapshotCount.snapshotCount = parseInt(snapshotId);
        this.id = parseInt(snapshotId);
      });

      const btnIcon = document.createElement('div');
      btnIcon.className = 'btn-icon';
      btnIcon.style.cssText =
        'color: #8029B6; align-items: center; display: flex;';

      const materialSymbol = document.createElement('span');
      materialSymbol.style.cssText = 'display:flex;';
      materialSymbol.innerHTML =
        '<img src=' +
        (true
          ? 'assets/ImagesSnapshot/Public/snapshot_icon_white.svg'
          : 'assets/ImagesSnapshot/Public/snapshot_icon_purpl.svg') +
        '>';

      const btnText = document.createElement('div');
      btnText.className = 'btn-text';
      btnText.style.cssText =
        'align-items: center; font-size: 0.75rem; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;';
      btnText.textContent = this.snapshotName;
      btnIcon.appendChild(materialSymbol);
      snapshotButton.appendChild(btnIcon);
      snapshotButton.appendChild(btnText);
      element.appendChild(snapshotButton);
      this._configService.ifDataExists = true;
    }
  }
  standaloneOptions = { standalone: true };
  decimalConfig: { tabular: string; charts: string; excel: string; ppt: string } = {
    tabular: 'chart',
    charts: 'chart',
    excel: 'chart',
    ppt: 'chart'
  };

  showStaticTextArea(event: Event) {
    this.showStaticTextAreaFlag = true;
  }

  hideStaticTextArea(event: Event) {
    this.showStaticTextAreaFlag = false;
  }

  getSelectedValueStudyName(option: any, value: string): void {
    // For multiple select checkboxes
    this.checkedList = []; // single select

    this.studyNames.forEach((study: any) => {
      study.selected = false;
    })
    const studyNameRadios = document.getElementsByClassName('studyNameRadio');
    for (let i = 0; i < studyNameRadios.length; i++) {
      const radio = studyNameRadios[i] as HTMLInputElement;
      radio.checked = false;
    }
    this.clientDetails.clientDetails.selectedStudy = option.name;
    // Persist selection so other components/pages can read it if needed
    try { localStorage.setItem('selectedStudy', option.name); } catch (e) { }
    option.selected = option.selected == null ? true : !option.selected;
    if (option.selected) {
      // If checkbox is checked, add value to checkedList
      this.checkedList.push(value);
    } else {
      // If checkbox is unchecked, remove value from checkedList
      const index = this.checkedList.indexOf(value);
      if (index !== -1) {
        this.checkedList.splice(index, 1);
      }
    }
    
    // Load custom base metrics for the selected study
    this.loadCustomBaseMetrics();
    
    // Load audience comparison data for the selected study
    this.loadAudienceComparisonData();
    
    // Fetch study-specific entry point data (sets isRespondentLevelFormat and related flags)
    this.getStudyDetails();
    
    this.FilterEPandDimData();

  }

  loadCustomBaseMetrics() {
    if (this.clientDetails.clientDetails.selectedStudy && this.data) {
      const matchingStudy = this.data.find(
        (item: any) => item.configData?.study === this.clientDetails.clientDetails.selectedStudy
      );
      if (matchingStudy && matchingStudy.configData?.customBaseMetrics) {
        this.customBaseMetrics = matchingStudy.configData.customBaseMetrics;
      } else {
        this.customBaseMetrics = [];
      }
    }
  }

  async loadAudienceComparisonData() {

    if (!this.clientDetails.clientDetails.selectedStudy || !this.clientDetails.clientDetails.client_name) {
      return;
    }

    try {
      const response = await this._configService
        .getAudienceSnapshotOptions(
          this.clientDetails.clientDetails.client_name, 
          this.clientDetails.clientDetails.selectedStudy
        )
        .toPromise();
      
      // Check if response.Data is not empty before processing
      if (!response.Data || response.Data.trim() === '' || response.Data === '[]' || response.Data === '{}') {
        this.audienceComparision = [];
        this.filteredAudienceComparision = [];
        this.totalSampleList = [];
        this.filteredTotalSample = [];
        this.brandList = [];
        this.filteredBrandList = [];
        return;
      }
      
      const data = JSON.parse(response.Data);
      const uniqueData = this.getUniqueVariableResponseCombinations(data);   
      // Extract Audience_ModConf from all objects in the array
      this.AudienceVariableList=uniqueData;
      this.customSnapshotService.uniqueAudienceData = uniqueData;

      const brandData = this.UniqueBrandData(data);

      this.customSnapshotService.uniqueBrandData = brandData;

    // Initialize Brand list
    this.brandList = brandData;
    this.filteredBrandList = brandData ? [...brandData] : [];
    // Auto-select first brand if available and none is currently selected
    if (brandData && brandData.length > 0 && !this.selectedBrand) {
      this.selectedBrand = {
        config_name: brandData[0].response_label,
        response_code: brandData[0].response_label,
        // metric_group: brandData[0].metric_group,
        is_snapshot: brandData[0].is_snapshot,
        is_selected: true
      };
    }
      if (data && Array.isArray(data) && data.length > 0) {
        const allAudienceModConf: any[] = [];
        
        // Loop through each object and extract Audience_ModConf
        data.forEach((item: any) => {
          if (item.Audience_ModConf) {
            allAudienceModConf.push(item);
          }
        });
        
        // Get unique audience module configuration
        if (allAudienceModConf.length > 0) {
          const uniqueAudienceModConf = this.getUniqueAudienceModConf(allAudienceModConf);
          
          this.audienceComparision = uniqueAudienceModConf;
          this.filteredAudienceComparision = uniqueAudienceModConf;
          
          // Initialize Total Sample list with the same data
          this.totalSampleList = uniqueAudienceModConf;
          this.filteredTotalSample = uniqueAudienceModConf;
          
          // Restore previously selected items if they exist
          this.restoreAudienceSelections();
        } else {        
          this.audienceComparision = [];
          this.filteredAudienceComparision = [];
          this.totalSampleList = [];
          this.filteredTotalSample = [];
          this.brandList = [];
          this.filteredBrandList = [];
        }
      }
      
      this.cdr.detectChanges();
    } catch (error) {
      console.error("Error loading audience comparison data:", error);
      this.audienceComparision = [];
      this.filteredAudienceComparision = [];
      this.totalSampleList = [];
      this.filteredTotalSample = [];
      this.brandList = [];
      this.filteredBrandList = [];
    }
  }

  restoreAudienceSelections() {
    let hasAudienceSelections = false;
    let hasTotalSampleSelection = false;
    
    // Restore audience comparison selections
    if (this.selectedAudienceComparisons && this.selectedAudienceComparisons.length > 0) {
      hasAudienceSelections = true;
      
      // Mark items as selected in the audience comparison list
      if (this.audienceComparision && Array.isArray(this.audienceComparision)) {
        this.audienceComparision.forEach((item: any) => {
          const isSelected = this.selectedAudienceComparisons.some(
            selected => selected.variable_code === item.variable_code
          );
          if (isSelected) {
            item.is_selected = true;
          }
        });
      }
      
      // Sort to show selected items first
      this.sortAudienceComparisonList();
      
      // Open the audience comparison dropdown
      this.showAudienceComparisonDropdown = true;
    }
    
    // Restore total sample selection
    if (this.selectedTotalSample && this.selectedTotalSample.variable_code) {
      hasTotalSampleSelection = true;
      
      // Mark item as selected in the total sample list
      if (this.totalSampleList && Array.isArray(this.totalSampleList)) {
        const matchingItem = this.totalSampleList.find(
          item => item.data_variable_code === this.selectedTotalSample.variable_code
        );
        if (matchingItem) {
          matchingItem.is_selected = true;
        }
      }
      
      // Sort to show selected item first
      this.sortTotalSampleList();
      
      // Open the total sample dropdown
      this.showTotalSampleDropdown = true;
    }
    
    this.cdr.detectChanges();
  }

  getStudyDetails() {
    let parameter = {
      snapshot_name: this.clientDetails.clientDetails.study,
      client_name: this.clientDetails.clientDetails.client_name,
      client_code: this.clientDetails.clientDetails.client_name,
    };
    this._configService
      .getSnapshotEntryPointData(parameter)
      .pipe(takeUntil(this.destroy$), debounceTime(100))
      .subscribe((data) => {
        this._loaderService.showLoader();
        this.entryPointsData = JSON.parse(data.Data);
        this.snapshotData = this.entryPointsData.Common_config;
        // this.snapshotDataConfig = this.snapshotData.snap_config;
        // //this.selectedWeight=this.snapshotData.
        this.aggregatedVariables = this.snapshotData?.aggregatedvariables;
          var x = [];
          this.isRespondentLevelFormat = false;
          for (let i = 0; i < this.snapshotData?.dataformat.length; i++) {
            if (this.snapshotData.dataformat[i].value == true) {
              x.push(this.snapshotData.dataformat[i].key);
              if (this.snapshotData.dataformat[i].key === 'Respondent Level') {
                this.isRespondentLevelFormat = true;
              }
            }
          }
          for (let j = 0; j < x.length; j++) {
            if (x[j] == 'Respondent Level') {
              this._configService.isRespondentLevel = true;
              this._configService.isSemiAggregatedData = false;
              this._configService.isAggregatedData = false;
            } else if (x[j] == 'Semi-Aggregated') {
              this._configService.isSemiAggregatedData = true;
              this._configService.isAggregatedData = false;
              this._configService.isRespondentLevel = false;
            } else if (x[j] == 'Aggregated') {
              this._configService.isAggregatedData = true;
              this._configService.isRespondentLevel = false;
              this._configService.isSemiAggregatedData = false;
            }
          }

        this.cdr.detectChanges();
        this._loaderService.hideLoader();
      });
  }

  FilterEPandDimData() {
    if (this.data.length != 0) {
      this.snapshotDetails.dimensionsDetails = [];
      this.snapshotDetails.entryPointsDetails = [];
      if (this.checkedList.length != 0 && this.checkedList.length > 1) {
        for (let i = 0; i < this.data.length; i++) {
          for (
            let j = 0;
            j < this.data[i].configData.entry_point?.length;
            j++
          ) {
            this.snapshotDetails.entryPointsDetails.push(
              {
                "code": this.data[i].configData.entry_point[j].variable_code,
                "label": this.data[i].configData.entry_point[j].variable_label
              }
            );
          }
          for (let k = 0; k < this.data[i].configData.dimension?.length; k++) {
            this.snapshotDetails.dimensionsDetails.push(
              {
                "code": this.data[i].configData.dimension[k].variable_code,
                "label": this.data[i].configData.dimension[k].variable_label
              }
            );
          }
        }
        // Get unique dimensions
        this.snapshotDetails.dimensionsDetails = Array.from(
          new Set(this.snapshotDetails.dimensionsDetails)
        );
        // Get unique entry points
        this.snapshotDetails.entryPointsDetails = Array.from(
          new Set(this.snapshotDetails.entryPointsDetails)
        );
      } else if (this.checkedList.length == 1) {
        let nameOfStudySelected = this.checkedList[0];
        let filteredData = this.data.filter(
          (item: any) => item.configData?.study === nameOfStudySelected
        );
        if (filteredData?.[0]?.configData?.entry_point) {
          for (
            let j = 0;
            j < filteredData[0].configData.entry_point.length;
            j++
          ) {
            this.snapshotDetails.entryPointsDetails.push(
              {
                "code": filteredData[0].configData.entry_point[j].variable_code,
                "label": filteredData[0].configData.entry_point[j].variable_label
              }
            );
          }
        
        for (let k = 0; k < filteredData[0].configData.dimension.length; k++) {
          this.snapshotDetails.dimensionsDetails.push(
            {
              "code": filteredData[0].configData.dimension[k].variable_code,
              "label": filteredData[0].configData.dimension[k].variable_label
            }
          );
        }
        }
      } 
    else {
        this.snapshotDetails.entryPointsDetails = [
          { variable_label: '', is_selected: false, variable_code: '' },
        ];
        this.snapshotDetails.dimensionsDetails = [
          { variable_label: '', is_selected: false, variable_code: '' },
        ];
      }
      
      this.PopulateEntryPointsAndDimensions();
    }
  }

  outputconfigchecked(item: any) {
    this.outputconfiguration.forEach((element: any) => {
      if (item === element) {
        element.selected = true;
        this.outputConfig = element.value;
      } else {
        element.selected = false;
      }
    });
  }

  stickyDefaultchecked(item: any) {
    this.stickyDefaultSelection.forEach((element: any) => {
      if (item === element) {
        element.selected = true;
        this.stickyDefaultSelected = element.value;
      } else {
        element.selected = false;
      }
    });
  }

  saveSelectionChecked(item: any, event: any) {
    this.checkBoxClick(item, event, this.saveSelection, this.saveSelectionCheckedList)
  }
  userManagementchecked(item: any, event: any) {
    this.checkBoxClick(item, event, this.userManagementSelection, this.userManagementCheckedList)
  }

  additionalCheckBoxchecked(item: any, event: any) {
    if(event.target.checked && item.name == "Static Time Frame") {
      sessionStorage.setItem('isSTF','true');
      this.isStaticTimeFrame = true;
      this._configService.isStaticTimeFrame = true;

      // if(this.isPreviousPeriosOrYear){
      //   this.uncheckOnError(item, event);
      //   this.errorPopup("Significance with respect to timeperiod cannot be selected with static time frame.", 'Alert');
      //   return;
      // }

      const conflictSelected = this.comparisonPoints.some(point =>
        (point.value === 'previousYear' || point.value === 'previousPeriod') && point.selected
      );

      if (conflictSelected) {
        this.uncheckOnError(item, event);
        this.errorPopup("Significance with respect to timeperiod cannot be selected with static time frame.", 'Alert');
        return;
      }
      const isReferenceSelected = this.comparisonPoints.some(point =>
        point.value === 'reference' && point.selected);

      if(isReferenceSelected) {
        // No popup needed for Reference with STF
      }
    }
    else if(!event.target.checked && item.name == "Static Time Frame") {
      this.isStaticTimeFrame = false;
      this._configService.isStaticTimeFrame = false;
      sessionStorage.setItem('isSTF','')
    }

    this.checkBoxClick(item, event, this.additionalCheckBoxSelection, this.additionalCheckBoxCheckedList);
  }

  customContentChecked(item: any, event: any) {
    this.checkBoxClick(item, event, this.customContentSelection, this.customContentCheckedList)
  }

  checkBoxClick(item: any, event: any, Selection: any, SelectionCheckedList: any, uncheckError: boolean = false) {
    Selection.forEach((i: any) => {
      if (event.target.checked && !uncheckError) {
        if (i == item) {
          i.selected = true;
          const existingItem = SelectionCheckedList.find(
            (j: any) => j.key === i.name
          );
          if (!existingItem) {
            SelectionCheckedList.push({
              key: i.name,
              value: i.selected,
            });
          }
        }
      } else {
        if (i == item) {
          i.selected = false;
          // Update the array without reassigning
          const index = SelectionCheckedList.findIndex(
            (j: any) => j.key === item.name
          );
          if (index > -1) {
            SelectionCheckedList.splice(index, 1); // Remove the unchecked item
          }
        }
      }
    });
  }
  errorPopup(message: string, headerTxt: string = 'Error'): void {
    const alertObj: AlertMessageModel = {
      header: headerTxt,
      message: message,
      show: true,
    };
    this._alertService.showAlert(alertObj);
  }

  isPreviousPeriosOrYear:boolean=false;
  comparisionChecked(item: any, event: any) {
    let isSTF =   sessionStorage.getItem('isSTF') == "true";

    if (event.target.checked) {
      this.lastSelectedOption = item;
      this.lastSelectedType = 'Comparison';
    }

    this.comparisonPoints.forEach((i: any) => {
      if (event.target.checked) {
        if (i == item) {
          // Check for Previous Year or Previous Period with STF
          if ((i.value === 'previousYear' || i.value === 'previousPeriod')) {
            this.isPreviousPeriosOrYear = true;
            if (this.isStaticTimeFrame || isSTF) {
              this.uncheckOnError(item, event);
              this.errorPopup("Significance with respect to timeperiod cannot be selected with static time frame.", 'Alert');
              return;
            }
          }
          i.selected = true;
          this.comparisionCheckedList.push({
            key: i.name,
            value: i.selected,
          });

          // No popup needed for Reference with STF - even if STF was selected first
          if (i.value === 'reference' && this.isStaticTimeFrame) {
            // No popup
          }
        }
      } else {
        if (i == item) {
          if ((i.value === 'previousYear' || i.value === 'previousPeriod')) {
            // Check if any other Previous Year or Period is still selected
            const anyOtherPrevSelected = this.comparisonPoints.some(
              cp => cp !== item &&
                   (cp.value === 'previousYear' || cp.value === 'previousPeriod') &&
                   cp.selected
            );
            this.isPreviousPeriosOrYear = anyOtherPrevSelected;
          }
          i.selected = false;
          this.comparisionCheckedList = this.comparisionCheckedList.filter(
            (j: any) => j !== i
          );
        }
        this.comparisionCheckedList = this.comparisionCheckedList.filter(
          (j: any) => j.key !== item.name
        );
      }
    });
  }

  // comparisionChecked(item: any, event: any) {
  //   if (event.target.checked) {
  //     this.lastSelectedOption = item;
  //     this.lastSelectedType = 'Comparison';
  //   }

  //   this.comparisonPoints.forEach((point: any) => {
  //     if (point === item) {
  //       if (event.target.checked) {
  //         // Conflict check: Selecting Previous Year or Period while STF is active
  //         if ((point.value === 'previousYear' || point.value === 'previousPeriod')) {
  //           this.isPreviousPeriosOrYear = true;

  //           if (this.isStaticTimeFrame) {
  //             this.uncheckOnError(item, event);
  //             this.errorPopup(
  //               "Significance with respect to timeperiod cannot be selected with static time frame.",
  //               'Alert'
  //             );
  //             return;
  //           }
  //         }

  //         point.selected = true;
  //         this.comparisionCheckedList.push({
  //           key: point.name,
  //           value: point.selected,
  //         });

  //         // No popup needed for reference
  //       } else {
  //         // Unchecking logic
  //         point.selected = false;

  //         if (point.value === 'previousYear' || point.value === 'previousPeriod') {
  //           const anyOtherPrevSelected = this.comparisonPoints.some(cp =>
  //             cp !== item &&
  //             (cp.value === 'previousYear' || cp.value === 'previousPeriod') &&
  //             cp.selected
  //           );
  //           this.isPreviousPeriosOrYear = anyOtherPrevSelected;
  //         }

  //         this.comparisionCheckedList = this.comparisionCheckedList.filter(
  //           (j: any) => j.key !== item.name
  //         );
  //       }
  //     }
  //   });
  // }

  signiFicanceTypeChecked(item: any, event: any) {
    this.significance.forEach((i: any) => {
      if (event.target.checked) {
        if (i == item) {
          i.selected = true;
          this.significanceTypeCheckedList.push(i);
        }
      } else {
        if (i == item) {
          i.selected = false;
          this.significanceTypeCheckedList =
            this.significanceTypeCheckedList.filter((j: any) => j !== i);
          this.significanceTypeCheckedList =
            this.significanceTypeCheckedList.filter(
              (j: any) => j.key !== i.name
            );
        }
      }
    });
  }

  multipleConfidenceChecked(item: any, event: any) {
    this.multipleConfidence.forEach((i: any) => {
      if (event.target.checked) {
        if (i == item) {
          i.selected = true;
          this.multipleConfidenceCheckedList.push(i);
        }
      } else {
        if (i == item) {
          i.selected = false;
          this.multipleConfidenceCheckedList =
            this.multipleConfidenceCheckedList.filter((j: any) => j !== i);
          this.multipleConfidenceCheckedList =
            this.multipleConfidenceCheckedList.filter(
              (j: any) => j.key != i.name
            );
        }
      }
    });
    this.refreshSelectedConfidenceLevels();
    this.syncDefaultConfidenceLevel();
  }

  refreshSelectedConfidenceLevels(): void {
    this.selectedConfidenceLevels = (this.multipleConfidence || []).filter(
      (item: any) => item.selected
    );
    try { this.cdr.markForCheck(); } catch (e) {}
  }

  onDefaultConfidenceLevelChange(value: string): void {
    console.log('[Snapshot Default CL] dropdown change:', value);
    this.defaultConfidenceLevel = (value || '').toString().trim();
    console.log('[Snapshot Default CL] after change:', this.defaultConfidenceLevel);
    try { this.cdr.markForCheck(); } catch (e) {}
  }

  syncDefaultConfidenceLevel(): void {
    this.refreshSelectedConfidenceLevels();
    const selected = this.selectedConfidenceLevels;
    const before = this.defaultConfidenceLevel;
    if (selected.length === 0) {
      this.defaultConfidenceLevel = '';
      console.log('[Snapshot Default CL] sync cleared (no selected levels). before=', before);
      try { this.cdr.markForCheck(); } catch (e) {}
      return;
    }
    const keys = selected.map((item: any) => item.name || item.key);
    const current = (this.defaultConfidenceLevel || '').toString().trim();
    if (!current || !keys.includes(current)) {
      this.defaultConfidenceLevel = keys[0];
      console.log('[Snapshot Default CL] sync reset. before=', before, 'current=', current, 'keys=', keys, 'after=', this.defaultConfidenceLevel);
    } else {
      console.log('[Snapshot Default CL] sync keep. value=', current, 'keys=', keys);
    }
    try { this.cdr.markForCheck(); } catch (e) {}
  }

    replaceSpaceWithHypenLowerCase(text: string) {
    if (this.isNullOrEmpty(text))
      return text;

    return text.trim().toLowerCase().split(' ').join('-');
  }
    onDeleteFileClick() {
    let folderName = this.replaceSpaceWithHypenLowerCase(this.selected_FolderName)
    let fileitem = this.documentFilesList.find((x: FilesWithIdentifiers) => {
      return x.identifier == folderName && x.fileName == this.selected_FileName
    });
    if (fileitem != undefined && fileitem != null) {
      if (fileitem.file != undefined && fileitem.file != null) {
        this.documentFilesList = this.documentFilesList.filter((x: FilesWithIdentifiers) => {
          if (x.fileName != fileitem?.fileName) {
            return true;
          }
          return x.identifier != fileitem?.identifier;
        })
      }
      else {
        fileitem.is_deleted = true;
      }
      this.errorPopup("Deleted the File : " + this.selected_FileName + " under Folder : " + this.selected_FolderName,"Alert")
      this.selected_FileName = this.otherConstants.FILE_SELECTED_DEFAULT_VAL;
      this.onFolderClick(this.selected_FolderName)
    } 
  }
    onDocFileChange(event: Event) {
    let input = event.target as HTMLInputElement;
    if (input?.files && input.files.length > 0) {
      if (input.files[0]) {
        const maxSizeInBytes = 4 * 1024 * 1024; // 4 MB
        if (input.files[0].size > maxSizeInBytes) {
          this.errorPopup("The size limit for individual file is 4MB. Kindly upload files accordingly");
          input.value = '';
          return;
        }
        //validate Whether it is sample file or custom logo file  upload
        let doc_filename = input.files[0].name;
        let selectedFolder = this.replaceSpaceWithHypenLowerCase(this.selected_FolderName)
        let fileItem = this.documentFilesList.find((x: FilesWithIdentifiers) => {
          return x.fileName == doc_filename && x.identifier == selectedFolder;
        })
        if (fileItem != undefined && fileItem != null) {
          this.errorPopup("File Already Exists under the Folder : " + this.selected_FolderName)
        }
        else {
          this.document_FileName = doc_filename;
          this.documentFilesList.push({
            file: input.files[0],
            fileName: doc_filename,
            identifier: selectedFolder,
            is_deleted: false,
            url: ""
          })
          this.onFolderClick(this.selected_FolderName)
          this.errorPopup("File uploaded under the Folder : " + this.selected_FolderName, "Alert")
        }
        input.value = '';

        // this.fileName = this.sampleFile.name; 
        // call to process the sample file
        //this.processFile(this.sampleFile);
      }
    }
  }

    onFileDropdownClick(): void {
      this.showFiles = !this.showFiles;
    }

  // Close folder/file dropdowns when clicking outside them
  @HostListener('document:click', ['$event'])
  handleDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    
    // Check for audience comparison dropdown
    const audienceComparisonDropdown = target.closest('.audience-comparison-dropdown');
    if (!audienceComparisonDropdown && this.showAudienceComparisonDropdown) {
      this.showAudienceComparisonDropdown = false;
      this.cdr.detectChanges();
    }
    
    // Check for total sample dropdown
    const totalSampleDropdown = target.closest('.total-sample-dropdown');
    if (!totalSampleDropdown && this.showTotalSampleDropdown) {
      this.showTotalSampleDropdown = false;
      this.cdr.detectChanges();
    }
    
    // Check for folder/file dropdowns
    if (target.closest('.folder-file-dropdown-container') || target.closest('.folder-file-dropdown')) {
      return;
    }
    
    // Check for study name dropdown
    if (target.closest('.drop-show') && target.closest('#SnapshotFieldsStudyNames')) {
      return;
    }
    if (target.closest('.drop-toggle') && target.closest('#SnapshotFieldsStudyNames')) {
      return;
    }
    
    // Check for custom base dropdown - don't close if clicking inside
    const customBaseDropdown = target.closest('.drop-show');
    const customBaseButton = target.closest('.drop-toggle');
    const isCustomBaseArea = target.closest('#SnapshotFieldsFilter_Function');
    
    if (isCustomBaseArea && (customBaseDropdown || customBaseButton)) {
      return;
    }
    
    // Otherwise close all dropdowns
    if (this.showFiles) { this.showFiles = false; }
    if (this.showFolders) { this.showFolders = false; }
    if (this.showCustomBaseDropdown) { this.showCustomBaseDropdown = false; }
  }
   /**
   * validate for null and length is greater than 0
   * @param input - . array
   * @returns {boolean}
   */
  notNullhasValue(input: any | null): boolean {
    return input !== null && input.length > 0;
  }
    onFolderClick(folderName: string) {
      this.showFolders = false;
      this.selected_FolderName = folderName;
      this.selected_FileName = this.otherConstants.FILE_SELECTED_DEFAULT_VAL;
      if (this.notNullhasValue(this.documentFilesList)) {
        let splitedName = folderName.trim().toLocaleLowerCase().split(' ');
        let idetifierName = splitedName.join('-');
        this.listOfFiles = this.documentFilesList.filter((x: FilesWithIdentifiers) => {
          return x.identifier === idetifierName && !x.is_deleted
        })
      }
      else {
        this.listOfFiles = [];
      }
      this.search_FileName = "";
      //this.search_FolderName="";
      // this.selected_FolderName=folderItem.folder
      // this.selected_FileName=this.otherConstants.FILE_SELECTED_DEFAULT_VAL;
      // this.listOfFiles=this.configData.document.filter((x:NestedDocument)=>{ 
      //   return x.folder===folderItem.folder
      // }).map((y:NestedDocument)=>{ return y.file});
    }
    onFileClick(file: FilesWithIdentifiers) {
      this.showFiles = false;
      this.selected_FileName = file.fileName;
      this.document_FileName = "";
      //this.search_FileName="";
    }
  
    /**
     * on select of client name in the dropdown => assign the selected client to the configuration data
     * @param selectedClient - . selected Client name 
     */
   
   isNullOrEmpty(input: string | null): boolean {
    return input === null || input.trim() === '';
  }
    onFileNameSearchChange() {
    let splitedName = this.selected_FolderName.trim().toLocaleLowerCase().split(' ');
    let idetifierName = splitedName.join('-');
    if (!this.isNullOrEmpty(this.search_FileName)) {
      this.listOfFiles = this.documentFilesList.filter((x: FilesWithIdentifiers) => {
        return !x.is_deleted && x.identifier === idetifierName &&
          x.fileName.toLowerCase().indexOf(this.search_FileName.toLowerCase()) > -1

      })
    }
    else {
      this.listOfFiles = this.documentFilesList.filter((x: FilesWithIdentifiers) => {
        return !x.is_deleted && x.identifier === idetifierName
      })
    }
  }
 onFolderNameSearchChange() {
    if (!this.isNullOrEmpty(this.search_FolderName)) {
      this.listOfFolders = FOLDER_LIST.filter((x: string) => {
        return x.toLowerCase().indexOf(this.search_FolderName.toLowerCase()) > -1
      })
    }
    else
      this.listOfFolders = [...FOLDER_LIST]
  }
  exportChecked(item: any, event: any) {
    this.export.forEach((i: any) => {
      if (event.target.checked) {
        if (i == item) {
          i.selected = true;
          this.exportCheckedList.push(i);
        }
      } else {
        if (i == item) {
          i.selected = false;
          this.exportCheckedList = this.exportCheckedList.filter(
            (j: any) => j !== i
          );
          this.exportCheckedList = this.exportCheckedList.filter(
            (j: any) => j.key !== i.name
          );
        }
      }
    });
  }
  onFolderDropdownClick(): void {
    this.showFolders = !this.showFolders;
  }
  submit() {
    
    // Check if cohort type has changed
    const cohortTypeChanged = this.originalAudienceCohortType !== this.audienceCohortType;
    
    // If cohort type changed, show level 1 warning
    if (cohortTypeChanged) {
      this._alertService.showAlert({
        header: 'Warning',
        message: 'All configurations in the Widget Library that depend on the current Audience mode will be cleared.',
        show: true,
        confirm: true,
        confirmText: 'Continue',
        cancelText: 'Cancel',
        onConfirm: () => {
          // Show loader before second popup
          this._loaderService.showLoader();
          
          // Use setTimeout to allow first popup to close before showing second
          setTimeout(() => {
            // Hide loader before showing second popup
            this._loaderService.hideLoader();
            
            // Level 2: Final Confirmation
            this._alertService.showAlert({
              header: 'Confirmation',
              message: 'Are you sure you want to proceed?',
              show: true,
              confirm: true,
              confirmText: 'Yes',
              cancelText: 'No',
              onConfirm: () => {
                // User confirmed both warnings, show loader and call API to clear audience sections
                this._loaderService.showLoader();
                this.cdr.detectChanges();
                
                // Call API to clear audience snapshot sections
                const clientName = this.clientDetails.clientDetails.client_name;
                const snapshotName = this.form?.get('snapshotName')?.value;
                
                this._configService.clearAudienceSnapshotSections(clientName, snapshotName)
                  .subscribe({
                    next: (response) => {                     
                      // Proceed with submission after API call succeeds
                      setTimeout(() => {
                        this.proceedWithSubmit();
                      }, 100);
                    },
                    error: (error) => {
                      console.error('Failed to clear audience snapshot sections', error);
                      this._loaderService.hideLoader();
                      this.isSubmit = true; // Re-enable submit button
                      this._alertService.showAlert({
                        header: 'Error',
                        message: 'Failed to clear audience snapshot sections. Please try again.',
                        show: true
                      });
                      this.cdr.detectChanges();
                    }
                  });
              },
              onCancel: () => {
                // User cancelled at level 2
                this.isSubmit = true; // Re-enable submit button
                this._loaderService.hideLoader();
                this.cdr.detectChanges();
              }
            });
          }, 300); // 300ms delay to allow popup to close
        },
        onCancel: () => {
          // User cancelled at level 1
          this.isSubmit = true; // Re-enable submit button
          this._loaderService.hideLoader();
          this.cdr.detectChanges();
        }
      });
      return; // Exit early, wait for user confirmation
    }
    
    // No cohort type change, proceed directly
    this.proceedWithSubmit();
  }

  private proceedWithSubmit() {
    this.isSubmit = false; //disabling the submit button
    this._loaderService.showLoader();
    if (
      this.clientDetails.snapshotCount < 20 ||
      this.currentSnapshotList.includes(this.form?.get('snapshotName')?.value)
    ) {
      this.commonchartservice.updateStudyNames(
        this.studyNames
          .filter((item: any) => item.selected)
          .map((item: any) => item.name)
      );
      const numberOfWidgetsCount = this.numberOfWidget;
      const snapshotType =
        this.form?.get('snapshotType')?.value != null
          ? this.form?.get('snapshotType')?.value
          : '';
      const docFolderType =
        this.form?.get('docFolderType')?.value != null
          ? this.form?.get('docFolderType')?.value
          : '';
      const docFileType =
        this.form?.get('docFileType')?.value != null
          ? this.form?.get('docFileType')?.value
          : '';

      const snapshotName =
        this.form?.get('snapshotName')?.value != null
          ? this.form?.get('snapshotName')?.value
          : '';
      if (snapshotName.length > 45) {

        this.showValidationErrorMessage('Snapshot Name Max Length');
        this.showErrorPopUp = true;
        this.popUpTitle = 'Error';
        this.isSubmit = true;
        this._loaderService.hideLoader();
        return;
      }

      const snapshotTypeCheckboxes = document.getElementsByClassName(
        'snapshot-type-checkbox'
      );
      let snapshotTypeDetails = [];
      let snapshotTypeSelectedArray = [];
      for (let i = 0; i < snapshotTypeCheckboxes.length; i++) {
        let snapshotTypeCheckbox = snapshotTypeCheckboxes[
          i
        ] as HTMLInputElement;
        let chk = snapshotTypeCheckbox.querySelector(
          'input[type="checkbox"]'
        ) as HTMLInputElement;
        if (chk !== null && chk.checked) {
          let ep = this.GetSelectedEntryPoint(chk.nextSibling?.textContent);
          let d = this.GetSelectedDimension(chk.nextSibling?.textContent);
          snapshotTypeSelectedArray.push(chk.nextSibling?.textContent);
          snapshotTypeDetails.push({
            snapshot_name: snapshotName,
            snapshot_type: chk.nextSibling?.textContent,
            entry_point: ep,
            dimension: d,
            cohortType:this.audienceCohortType
          });
        }
      }

      if (
        this.validationsOfSnapShotConfiguration(
          snapshotName,
          6,
          'Snapshot Name'
        )
        && this.validationsOfSnapShotConfiguration(this.checkedList, 1, 'Study Name') &&
        this.validationsOfSnapShotConfiguration(
          snapshotTypeSelectedArray,
          1,
          'Snapshot Type'
        ) &&
        // (this._configService.productSelected == "Standard" || this.validationsOfSnapShotConfiguration(
        //   numberOfWidgetsCount,
        //   1,
        //   'Number of Widgets'
        // )) &&
        ((!this.showStaticTextAreaFlag) || // Check if showStaticTextAreaFlag is false
          (this.showStaticTextAreaFlag &&
            this.validationsOfSnapShotConfiguration(
              this.statictext,
              1,
              'Static Text'
            ))) && // Check if showStaticTextAreaFlag is true and validate statictext
           
         ((!this.customBaseInput) || // Check if showStaticTextAreaFlag is false
          (this.customBaseInput &&
            this.validationsOfSnapShotConfiguration(
              this.selectedCustomBases,
              1,
              'Custom Base'
            ))) &&

        ((this.comparisionCheckedList.length == 0 &&
          this.multipleConfidenceCheckedList.length == 0) ||
          (this.comparisionCheckedList.length > 0 &&
            this.multipleConfidenceCheckedList.length > 0) ||
          (this.validationsOfSnapShotConfiguration(
            this.comparisionCheckedList,
            1,
            'Comparision Points'
          ) &&
            // this.validationsOfSnapShotConfiguration(
            //   this.significanceTypeCheckedList,
            //   1,
            //   'Types of Significance'
            // ) &&
            this.validationsOfSnapShotConfiguration(
              this.multipleConfidenceCheckedList,
              1,
              'Multiple Confidence Levels'
            ))) &&
        this.CheckSnapshotNameDuplicate(snapshotName) &&
        // Validate Audience Snapshot selections
        this.validateAudienceSnapshotSelections(snapshotTypeSelectedArray)
        // &&
        // this.validationsOfSnapShotConfiguration(
        //   this.exportCheckedList,
        //   1,
        //   'Export'
        // )
      ) {
        // this._loaderService.showLoader();
        this.showPopUp = false;
        //this.showErrorPopUp = true;
        //this.errorheaderTitle = "  ";
        this.popUpTitle = "  ";
        this.popUpMessage = "";
        this.snapCountNum = this.snapshotCount.snapshotCount;
        this.isSubmitted.emit(true);

        let studyList = [];
        this._configService.clientSnapshotAllStudyNames = [];
        for (let i = 0; i < this.studyNames.length; i++) {
          if (this.checkedList.includes(this.studyNames[i].name)) {
            studyList.push({
              study_id: (i + 1).toString(),
              study_name: this.studyNames[i].name,
            });


            this._configService.clientSnapshotAllStudyNames.push({
              label: this.studyNames[i].name,
              value: this.studyNames[i].name
            });
          }
        }



        let outputConfigValue = '';
        const outputConfigRadios = document.querySelectorAll(
          "#outputconfiguration input[type='radio']"
        );
        outputConfigRadios.forEach((radio: any) => {
          if (radio.checked) {
            outputConfigValue = radio.value;
          }
        });

        let significance_type = [];
        for (let i = 0; i < this.significanceTypeCheckedList.length; i++) {
          if (this.significanceTypeCheckedList[i].name != undefined)
            significance_type.push({
              value: this.significanceTypeCheckedList[i].selected,
              key: this.significanceTypeCheckedList[i].name,
            });
          else {
            significance_type.push({
              value: this.significanceTypeCheckedList[i].value,
              key: this.significanceTypeCheckedList[i].key,
            });
          }
        }

        let multipleConfidence_CheckedList = [];
        for (let i = 0; i < this.multipleConfidenceCheckedList.length; i++) {
          if (this.multipleConfidenceCheckedList[i].name != undefined)
            multipleConfidence_CheckedList.push({
              value: this.multipleConfidenceCheckedList[i].selected,
              key: this.multipleConfidenceCheckedList[i].name,
            });
          else {
            multipleConfidence_CheckedList.push({
              value: this.multipleConfidenceCheckedList[i].value,
              key: this.multipleConfidenceCheckedList[i].key,
            });
          }
        }
        this.refreshSelectedConfidenceLevels();
        console.log('[Snapshot Default CL] before save payload:', {
          defaultConfidenceLevel: this.defaultConfidenceLevel,
          selectedConfidenceLevels: this.selectedConfidenceLevels.map((x: any) => x.name || x.key),
          multipleConfidence: this.multipleConfidence.map((x: any) => ({ name: x.name, selected: x.selected })),
          multipleConfidenceCheckedList: this.multipleConfidenceCheckedList
        });
        // Do not sync/overwrite user-selected default right before save

        let comparision_CheckedList = [];
        for (let i = 0; i < this.comparisionCheckedList.length; i++) {
          if (this.comparisionCheckedList[i].key != undefined)
            comparision_CheckedList.push({
              value: this.comparisionCheckedList[i].value,
              key: this.comparisionCheckedList[i].key,
            });
          // else{
          //   comparision_CheckedList.push({
          //     value: this.comparisionCheckedList[i].value,
          //     key: this.comparisionCheckedList[i].key,
          //   });
          // }
        }

        let export_CheckedList = [];
        for (let i = 0; i < this.exportCheckedList.length; i++) {
          if (this.exportCheckedList[i].name != undefined)
            export_CheckedList.push({
              value: this.exportCheckedList[i].selected,
              key: this.exportCheckedList[i].name,
            });
          else {
            export_CheckedList.push({
              value: this.exportCheckedList[i].value,
              key: this.exportCheckedList[i].key,
            });
          }
        }

        let saveSelection_CheckedList = [];
        for (let i = 0; i < this.saveSelectionCheckedList.length; i++) {
          if (this.saveSelectionCheckedList[i].name != undefined)
            saveSelection_CheckedList.push({
              value: this.saveSelectionCheckedList[i].selected,
              key: this.saveSelectionCheckedList[i].name,
            });
          else {
            saveSelection_CheckedList.push({
              value: this.saveSelectionCheckedList[i].value,
              key: this.saveSelectionCheckedList[i].key,
            });
          }
        }


        let custom_CheckedList = [];
        for (let i = 0; i < this.customContentCheckedList.length; i++) {
          if (this.customContentCheckedList[i].name != undefined)
            custom_CheckedList.push({
              value: this.customContentCheckedList[i].selected,
              key: this.customContentCheckedList[i].name,
            });
          else {
            custom_CheckedList.push({
              value: this.customContentCheckedList[i].value,
              key: this.customContentCheckedList[i].key,
            });
          }
        }

        let usermanagement_CheckedList = [];
        for (let i = 0; i < this.userManagementCheckedList.length; i++) {
          if (this.userManagementCheckedList[i].name != undefined)
            usermanagement_CheckedList.push({
              value: this.userManagementCheckedList[i].selected,
              key: this.userManagementCheckedList[i].name,
            });
          else {
            usermanagement_CheckedList.push({
              value: this.userManagementCheckedList[i].value,
              key: this.userManagementCheckedList[i].key,
            });
          }
        }

        let additional_CheckedList = [];
        for (let i = 0; i < this.additionalCheckBoxCheckedList.length; i++) {
          if (this.additionalCheckBoxCheckedList[i].name != undefined)
            additional_CheckedList.push({
              value: this.additionalCheckBoxCheckedList[i].selected,
              key: this.additionalCheckBoxCheckedList[i].name,
            });
          else {
            additional_CheckedList.push({
              value: this.additionalCheckBoxCheckedList[i].value,
              key: this.additionalCheckBoxCheckedList[i].key,
            });
          }
        }

        let mode = this.dataExistance ? 'Update' : 'Insert';
        let resetSel = (
          document.querySelector(
            '.reset-sel input[type="radio"]:checked'
          ) as HTMLInputElement
        )?.value;
        // this.resetSelectionFlag =
        //   resetSel.toLowerCase() == 'yes' ? true : false;
        let snapshotLayout = Number(
          this.selectedwidget.replace(' Widget Layout', '')
        );

        const emptyTotalSample = {
          variable_label: "",
          variable_code: "",
          response_code: "",
          config_name: "",
          is_selected: false
        };

        let dataObject = {
          configData: {
            client_code: this.clientDetails.clientDetails.client_name,
            client_name: this.clientDetails.clientDetails.client_name,
            product: this._configService.productSelected,
            product_type: this._configService.templateSelected,
            snapshot_name: snapshotName,
            snapshotType_details: snapshotTypeDetails,
            study_list: studyList,
            number_of_widgets: numberOfWidgetsCount,
            snapshot_layout: snapshotLayout.toString(),
            is_output_configuration:
              outputConfigValue.toLowerCase() == 'admin' ? true : false,
            is_answer_base: this.answerBaseInput,
            is_static_text_enable: this.showStaticTextAreaFlag,
            static_text: this.showStaticTextAreaFlag ? this.statictext : "",
            significance_type: significance_type,
            confidence_level: multipleConfidence_CheckedList,
            default_confidence_level: this.defaultConfidenceLevel || '',
            is_reset_selections: this.resetSelectionFlag,
            sticky_selection_type: this.stickyDefaultSelected,
            sig_testing_vs: comparision_CheckedList,
            export_download: export_CheckedList,
            widget_detail: [],
            saveselection: saveSelection_CheckedList,
            custom_content: custom_CheckedList,
            user_management: usermanagement_CheckedList,
            additional_list: additional_CheckedList,
            decimal_point_configuration: {
              tabular: this.decimalConfig.tabular,
              charts: this.decimalConfig.charts,
              excel: this.decimalConfig.excel,
              ppt: this.decimalConfig.ppt,
            },
            // selectedCustomBaseMetric: this.selectedCustomBases,
            audienceCohortType: snapshotTypeSelectedArray.includes('Audience Snapshot') ? this.audienceCohortType : '',
            audienceComparsion: snapshotTypeSelectedArray.includes('Audience Snapshot') ? this.selectedAudienceComparisons : [],
            audienceTotalSample: snapshotTypeSelectedArray.includes('Audience Snapshot') ? (this.selectedTotalSample == null ? emptyTotalSample : this.selectedTotalSample) : null,
            selectedBrand: snapshotTypeSelectedArray.includes('Audience Snapshot') ? this.selectedBrand : null,
            isCustomBaseSelected: this.customBaseInput,
            selectedCustomBaseMetric: this.customBaseInput ? this.selectedCustomBases : [],
          },
          mode: mode,
          documents: this.documentFilesList,
        };
        console.log('[Snapshot Default CL] dataObject.configData.default_confidence_level =',
          dataObject.configData.default_confidence_level);
        console.log('[Snapshot Default CL] full confidence payload:', {
          confidence_level: dataObject.configData.confidence_level,
          default_confidence_level: dataObject.configData.default_confidence_level
        });


        this._configService.noOfWidget(dataObject.configData.number_of_widgets);
        this._configService.widgetDivs(dataObject.configData.snapshot_layout);

        let files_list: FilesWithIdentifiers[] = []
        if (this.documentFilesList.length > 0) {
          files_list = this.documentFilesList.filter((x: FilesWithIdentifiers) => {
            return x.file != undefined && x.file != null
          })
        }

        this.subscriptions.add(
          this._configService
            .addSnapshotConfiguration(dataObject, files_list)
            .subscribe((a) => {
              //this.showErrorPopUp=false;

              if (a.body.Data == '"Saved Successfully"') {
                //this.showPopUp = false;
                //this.showErrorPopUp = true;
                //this.errorheaderTitle = "Success";
                //this.showErrorPopUp = true;
                this.popUpTitle = "Success";
                this.popUpMessage = 'Submitted Successfully';
                // Update original cohort type after successful save
                this.originalAudienceCohortType = this.audienceCohortType;
                // Only add to UniqueSnapshots if it's a new snapshot (Insert mode), not an update
                this._configService.decimalPointConfig = { ...this.decimalConfig };
                if (this._configService.alreadySavedSnapshotData) {
                  this._configService.alreadySavedSnapshotData.decimal_point_configuration = { ...this.decimalConfig };
                }
                this.isSubmitted.emit(true);
                if (mode === 'Insert') {
                  this.clientDetails.clientDetails.configdata.forEach(
                    (element: any) => {
                      if (
                        element.ClientName ==
                        this.clientDetails.clientDetails.client_name
                      ) {
                        if (element.UniqueSnapshots != undefined) {
                          // Check if snapshot already exists to prevent duplicates
                          if (!element.UniqueSnapshots.includes(snapshotName)) {
                            // Push just the snapshot name string, not a complex object structure
                            element.UniqueSnapshots.push(snapshotName);
                            this.clientDetails.snapshotCount += 1;
                          }
                        } else {
                          if (!element.UniqueStudies.includes(snapshotName)) {
                            element.UniqueStudies.push(snapshotName);
                            this.clientDetails.snapshotCount += 1;
                          }
                        }
                      }
                    }
                  );
                }


                this.clientDetails.clientDetails.study = snapshotName;

              }
              else if (a.body.Data == '"Updated Successfully"') {
                //this.showPopUp = false;
                //this.showErrorPopUp = true;
                //this.showErrorPopUp = true;
                this.popUpTitle = "Info";
                this.popUpMessage = 'Updated Successfully';
                // Update original cohort type after successful update
                this.originalAudienceCohortType = this.audienceCohortType;
                this._configService.decimalPointConfig = { ...this.decimalConfig };
                if (this._configService.alreadySavedSnapshotData) {
                  this._configService.alreadySavedSnapshotData.decimal_point_configuration = { ...this.decimalConfig };
                }
                this.isSubmitted.emit(true);

              } else {
                //this.showErrorPopUp = true;
                //this.showErrorPopUp = true;
                this.errorheaderTitle = 'Error';
                this.popUpTitle = "Error";
                //this.showPopUp = false;
                this.popUpMessage = 'Failed to Submit:' + a.body.Data;
                this.clientDetails.clientDetails.study = "";
              }
              this.isSubmit = true;
              this.showSubmitPopUp = true;
              this.cdr.detectChanges();
              this._loaderService.hideLoader();
            }));
      } else {
        this.showPopUp = false;
        this.isSubmit = true;
        this.showErrorPopUp = true;
        this.popUpTitle = "Error";
        this.errorheaderTitle = 'Error';
        if (this.clientDetails.clientDetails.study == "") {
          this.clientDetails.clientDetails.study = "";
        }
        if (this.popUpMessage == "")
          this.popUpMessage = 'Validation Failed!';
       }
    } else {
      this.showPopUp = false;
      this.isSubmit = true;
      //this.showErrorPopUp = true;
      this.popUpTitle = "Error";
      this.errorheaderTitle = 'Error';
      this.popUpMessage =
        'Failed to Submit:' +
        'You have reached the maximum limit of 20 snapshots. Please delete an existing snapshot before adding a new one.';
     }
   this._loaderService.hideLoader();
  }

  validationsOfSnapShotConfiguration(
    item: any,
    minLength: number = 1,
    messageSwitch: any
  ) {
    //this.showErrorPopUp = true;
    if (Array.isArray(item) && item.length < minLength) {
      this.showValidationErrorMessage(messageSwitch);
      return false;
    } else if (!Array.isArray(item) && item.length < minLength) {
      // Handle non-array cases
      this.showValidationErrorMessage(messageSwitch);
      return false;
    } else {
      return true;
    }
  }

  showValidationErrorMessage(messageSwitch: any) {
    switch (messageSwitch) {
      case 'Snapshot Name': {
        this.popUpMessage =
          'Please enter the SNAPSHOT NAME of minimum 6 characters. ';
        break;
      }
      
       case 'Snapshot Name Max Length': {
       this.popUpMessage =
      'Please enter the SNAPSHOT NAME of maximum 45 characters.';
        break;
        }

      case 'Study Name': {
        this.popUpMessage =
          'Please select the field STUDY NAMES. ';
        break;
      }
      case 'Snapshot Type': {
        this.popUpMessage = 'Please select the field SNAPSHOT TYPE. ';
        break;
      }
      case 'Number of Widgets': {
        this.popUpMessage = 'Please select the field NUMBER OF WIDGETS. ';
        break;
      }
      case 'Static Text': {
        this.popUpMessage = 'Please enter the field STATIC TEXT. ';
        break;
      }
      case "Custom Base":{
        this.popUpMessage = 'Please select at least one option in the field CUSTOM BASE. ';
        break;
      }
      case 'Comparision Points': {
        this.popUpMessage = 'Please select the field COMPARISION POINTS. ';
        break;
      }
      // case 'Types of Significance': {
      //   this.popUpMessage = 'Please select the field TYPES OF SIGNIFICANCE. ';
      //   break;
      // }
      case 'Multiple Confidence Levels': {
        this.popUpMessage =
          'Please select the field MULTIPLE CONFIDENCE LEVELS. ';
        break;
      }
      case 'Export': {
        this.popUpMessage = 'Please select the field EXPORT. ';
        break;
      }
      default:
        this.popUpMessage = 'Please enter all the fields...! ';
        break;
    }

    this.errorheaderTitle = 'Error';
  }

  validateAudienceSnapshotSelections(snapshotTypeSelectedArray: (string | null | undefined)[]): boolean {
    // If Audience Snapshot is not selected, validation passes
    if (!snapshotTypeSelectedArray.includes('Audience Snapshot')) {
      return true;
    }
    const hasBrandSelected = this.selectedBrand !== null && this.selectedBrand !== '';
    if (!hasBrandSelected) {
      this.popUpMessage = 'Please select a Brand for Audience Snapshot.'; 
    }
    // Audience Comparison and Total Sample are optional; submission is allowed when both are deselected
      // If Audience Snapshot is selected, check if at least one option is selected
    const hasAudienceCohortType = this.audienceCohortType !== '';
    const hasAudienceComparisons = this.selectedAudienceComparisons.length > 0;
    const hasTotalSample = this.selectedTotalSample !== null;
  
    // Validation fails if BOTH are false (neither is selected)
    if (this.audienceCohortType === "multiple" && !hasAudienceComparisons && !hasTotalSample) {
        this.popUpMessage = 'Please select at least one option: either Audience Comparison or Total Sample for Audience Snapshot.';
        this.errorheaderTitle = 'Error';
        return false;
      }
    return true;
  }

  SnapshotTypeClick(event: any, id: any) {
    const target = event.target as HTMLElement;
    const snapshotTypeCheckbox = target.closest('.snapshot-type-checkbox') as HTMLElement;
    const element = document.getElementById(id) as HTMLInputElement;
    const isChecked = element.checked;
    if (!isChecked) {
      const snapshotTypeCheckboxes = snapshotTypeCheckbox.querySelectorAll('input[type="checkbox"]');
      snapshotTypeCheckboxes.forEach((checkbox: any) => {
        if (checkbox.checked) {
          checkbox.checked = false;
        }
      });
    }
  }

  clearAll() {
    this.comparisionCheckedList = [];
    this.significanceTypeCheckedList = [];
    this.multipleConfidenceCheckedList = [];
    this.defaultConfidenceLevel = '';
    this.selectedConfidenceLevels = [];
    this.saveSelectionCheckedList = [];
    this.userManagementCheckedList = [];
    this.customContentCheckedList = [];
    this.exportCheckedList = [];
    this.checkedList = [];
    this.additionalCheckBoxCheckedList = [];
    this.comparisonPoints.forEach((item: any) => (item.selected = false));
    this.significance.forEach((item: any) => (item.selected = false));
    this.multipleConfidence.forEach((item: any) => (item.selected = false));
    this.saveSelection.forEach((item: any) => (item.selected = false));
    this.userManagementSelection.forEach((item: any) => (item.selected = false));
    this.customContentSelection.forEach((item: any) => (item.selected = false));
    this.export.forEach((item: any) => (item.selected = false));
    this.resetSelectionFlag = this.defaultResetSelectionFlag;
    this.outputConfig = this.defaultOutputConfig;
    this.stickyDefaultSelected = this.defaultStickyorDefault;
    this.selectedwidget = this.defaultselectedWidget;
    this.customBaseInput = false;
    this.selectedCustomBases = [];
    
    // Reset audience cohort type to default
    this.audienceCohortType = 'single';
    this.originalAudienceCohortType = 'single';

    this.outputconfiguration = [
      { id: 1, selected: true, name: 'Admin Defined', value: 'admin' },
      { id: 2, selected: false, name: 'User Defined', value: 'user' },
    ];
    this.stickyDefaultSelection = [
      { id: 1, selected: true, name: 'Sticky', value: 'sticky' },
      { id: 2, selected: false, name: 'Default', value: 'default' },
    ];
    this.reset = [
      { id: 1, selected: this.resetSelectionFlag, name: 'Yes', value: 'yes' },
      { id: 2, selected: !this.resetSelectionFlag, name: 'No', value: 'no' },
    ];
    this.answerBaseInput = this.defaultAnswerBaseInput;
    this.showStaticTextAreaFlag = this.defaultStaticTextAreaFlag;
    // const snapLayoutInput = document.querySelector(
    //   '.SnapshotFieldInputLayout'
    // ) as HTMLElement;
    //snapLayoutInput.innerHTML = this.selectedwidget;
    this.studyNames.forEach((study: any) => (study.selected = false));
    this.numberOfWidget = this.snapshotData.number_of_widgets;

    // this.form.reset();
    const studyNameValue = this.form.get('snapshotName')?.value;
    ;
    if (this.clientDetails.clientDetails.study != '') {
      this.form.reset({
        snapshotName: studyNameValue,
      });
    } else {
      this.form.reset();
    }

    const snapshotTypeCheckboxes = document.getElementsByClassName(
      'snapshot-type-checkbox'
    );

    let snapshotTypeDetails = [];
    for (let i = 0; i < snapshotTypeCheckboxes.length; i++) {
      let snapshotTypeCheckbox = snapshotTypeCheckboxes[
        i
      ] as HTMLInputElement;
      let chk = snapshotTypeCheckbox.querySelector(
        'input[type="checkbox"]'
      ) as HTMLInputElement;

      if (chk !== null && chk.checked) {
        let ep = this.GetSelectedEntryPoint(chk.nextSibling?.textContent);
        let d = this.GetSelectedDimension(chk.nextSibling?.textContent);
        snapshotTypeDetails.push({
          snapshot_type: chk.nextSibling?.textContent,
          entry_point: ep,
          dimension: d,
        });
      }
    }


    let condition = this.dataExistance ? this.snapshotData?.snapshotType_details?.length : snapshotTypeDetails.length;
    for (let j = 0; j < condition; j++) {
      for (let i = 0; i < snapshotTypeCheckboxes.length; i++) {
        let snapshotTypeCheckbox = snapshotTypeCheckboxes[
          i
        ] as HTMLInputElement;
        let chk = snapshotTypeCheckbox.querySelector(
          'input[type="checkbox"]'
        ) as HTMLInputElement;

        chk.checked = false;
      }
    }

    // add the this.numberOfWidget value to the form with FormControlName as 'widgetTypeForm'
    this.form.controls['widgetTypeForm'].setValue(this.numberOfWidget);


    this.ClearAlreadySelectedDimensions();
    this.ClearAlreadySelectedEntryPoints();
    this.CheckEnableDisableForFields();

    this.entryPointsSB = [
      { variable_label: '', is_selected: false, variable_code: '' },
    ];

    this.dimensionsSB = [
      { variable_label: '', is_selected: false, variable_code: '' },
    ];

    this.entryPointsMB = [
      { variable_label: '', is_selected: false, variable_code: '' },
    ];

    this.dimensionsMB = [
      { variable_label: '', is_selected: false, variable_code: '' },
    ];

    this.entryPointsMC = [
      { variable_label: '', is_selected: false, variable_code: '' },
    ];

    this.dimensionsMC = [
      { variable_label: '', is_selected: false, variable_code: '' },
    ];

    this.entryPointsMM = [
      { variable_label: '', is_selected: false, variable_code: '' },
    ];

    this.dimensionsMM = [
      { variable_label: '', is_selected: false, variable_code: '' },
    ];

     this.entryPointsAS = [
      { variable_label: '', is_selected: false, variable_code: '' },
    ];

      this.dimensionsAS = [
      { variable_label: '', is_selected: false, variable_code: '' },
    ];
  }

  //DELETE CONFIGURATION CODE:

  delete() {
    this.showDeletePopup = true;
  }
  receivedDeleteConfirmation(data: any) {

    this.showDeletePopup = false;
    if (data == 'yes') {
      //API CALL FOR DELETING
      this.subscriptions.add(
        this._configService
          .deleteSnapshot({
            client_code: this.clientDetails.clientDetails.client_name,
            snapshot_name: this.clientDetails.clientDetails.study,
          })
          .subscribe((res) => {

            if (res.Data == '"Deleted Successfully"') {
              const deletedElement = document.querySelector(
                '[title="' + this.clientDetails.clientDetails.study + '"'
              );
              if (deletedElement) deletedElement.remove();

              const navigationExtras = {
                state: {
                  deletedsnapshot: this.selectedSnapshotData.snapshotName,
                },
              };
              setTimeout(() => {
                this.router
                  .navigateByUrl('Snapshot/snapshotpreview', {
                    skipLocationChange: true,
                  })
                  .then(() => {
                    this.router.navigateByUrl(
                      'Snapshot/configuaration',
                      navigationExtras
                    );
                  });
              }, 100);
            }
          }));
      this.subscriptions.add(
        this._configService.deleteWidget({
          clientName: this.clientDetails.clientDetails.client_name,
          snapshotName: this.clientDetails.clientDetails.study,
        }).subscribe((res) => {

        }))
    }
    // });
    //}
  }

  //------------------------

  save() { }
  isStaticTimeFrame:boolean=false;
  AddAlreadyExistingData() {
    this.alreadyExisting.emit(true);
    this.form.controls['snapshotName'].setValue(
      this.snapshotData.snapshot_name
    );
    //this.form.controls['snapshotType'].setValue(this.snapshotData.snapshotType_details[0].snapshot_type);
    const studyNamesArea = document.getElementById(
      'studyNamesArea'
    ) as HTMLSpanElement;
    // Use only the first study for radio selection (radios are single-select)
    this.checkedList = this.snapshotData.study_list && this.snapshotData.study_list.length > 0
      ? [this.snapshotData.study_list[0].study_name]
      : [];
    this.FilterEPandDimData();

    if (studyNamesArea) {
      // Show only the first selected study in the button/hover (radios are single-select)
      studyNamesArea.innerHTML =
        this.checkedList.length > 0 ? this.checkedList[0] : 'Select';
    }

    this._configService.clientSnapshotAllStudyNames = [];
    for (let i = 0; i < this.studyNames.length; i++) {
      // mark selected only when it matches the single chosen study
      if (this.checkedList.includes(this.studyNames[i].name)) {
        this._configService.clientSnapshotAllStudyNames.push({
          label: this.studyNames[i].name,
          value: this.studyNames[i].name
        });
        this.studyNames[i].selected = true;
      } else {
        this.studyNames[i].selected = false;
      }
    }
    // If there is at least one selected study, set the clientDetails selectedStudy to the first one
    if (this.checkedList && this.checkedList.length > 0) {
      this.clientDetails.clientDetails.selectedStudy = this.checkedList[0];
    }

    // Ensure template updates (OnPush)
    try { this.cdr.detectChanges(); } catch (e) {}
    //this.form.controls['studyName'].setValue(this.snapshotData.study_list);
    this.form.controls['staticText'].setValue(this.snapshotData.static_text);
    this.selectedwidget = this.snapshotData.snapshot_layout + ' Widget Layout';
    // const snapLayoutInput = document.querySelector(
    //   '.SnapshotFieldInputLayout'
    // ) as HTMLElement;
    // snapLayoutInput.innerHTML = this.selectedwidget;

    this.snapshotLayout = this.snapshotData.snapshot_layout;
    this.numberOfWidget = this.snapshotData.number_of_widgets;
    // this.numberOfWidget = 0;

    this.showStaticTextAreaFlag = this.snapshotData.is_static_text_enable;
    this.answerBaseInput = this.snapshotData.is_answer_base;
    this.outputConfig = this.snapshotData.is_output_configuration
      ? 'admin'
      : 'user';
    this.stickyDefaultSelected = this.snapshotData.sticky_selection_type;
    this.resetSelectionFlag = this.snapshotData.is_reset_selections;
    this.comparisionCheckedList = this.snapshotData.sig_testing_vs;
    this.significanceTypeCheckedList = this.snapshotData.significance_type;
    this.multipleConfidenceCheckedList = this.snapshotData.confidence_level;
    this.defaultConfidenceLevel = this.snapshotData.default_confidence_level || '';
    this.saveSelectionCheckedList = this.snapshotData.saveselection;
    this.additionalCheckBoxCheckedList = this.snapshotData.additional_list;
    this.customContentCheckedList = this.snapshotData.custom_content;
    this.userManagementCheckedList = this.snapshotData.user_management;
    this.exportCheckedList = this.snapshotData.export_download;
    this.statictext = this.snapshotData.static_text;
    this.customBaseInput = this.snapshotData.isCustomBaseSelected ?? false;
    this.selectedCustomBases = this.snapshotData.selectedCustomBaseMetric ?? [];
    const d = this.snapshotData.decimal_point_configuration;
      this.decimalConfig = {
        tabular: d?.tabular ?? 'chart',
        charts:  d?.charts  ?? 'chart',
        excel:   d?.excel   ?? 'chart',
        ppt:     d?.ppt     ?? 'chart',
      };
      this._configService.decimalPointConfig = { ...this.decimalConfig }; 

    // Ensure studyNames selected flags are correctly set based on checkedList
    this.studyNames.forEach((item: any) => {
      item.selected = this.checkedList.includes(item.name);
    });

    // Trigger change detection so template updates (component uses OnPush)
    try {
      this.cdr.detectChanges();
    } catch (e) {
      // ignore detection errors
    }


    this.comparisonPoints.forEach((item: any) => {
      this.comparisionCheckedList.forEach((element: any) => {
        if (item.name == element.key) {
          item.selected = element.value;
        }
      });
    });

    this.significance.forEach((item: any) => {
      this.significanceTypeCheckedList.forEach((element: any) => {
        if (item.name == element.key) {
          item.selected = element.value;
        }
      });
    });
    this.multipleConfidence.forEach((item: any) => {
      this.multipleConfidenceCheckedList.forEach((element: any) => {
        if (item.name == element.key) {
          item.selected = element.value;
        }
      });
    });
    this.refreshSelectedConfidenceLevels();
    const loadedDefault = (this.snapshotData.default_confidence_level || '').toString().trim();
    const selectedKeys = this.selectedConfidenceLevels.map((item: any) => item.name || item.key);
    this.defaultConfidenceLevel =
      loadedDefault && selectedKeys.includes(loadedDefault)
        ? loadedDefault
        : (selectedKeys[0] || '');
    this.saveSelection.forEach((item: any) => {
      this.saveSelectionCheckedList?.forEach((element: any) => {
        if (item.name == element.key) {
          item.selected = element.value;
        }
      });
    });
    this.export.forEach((item: any) => {
      this.exportCheckedList.forEach((element: any) => {
        if (item.name == element.key) {
          item.selected = element.value;
        }
      });
    });
    this.userManagementSelection.forEach((item: any) => {
      this.userManagementCheckedList?.forEach((element: any) => {
        if (item.name == element.key) {
          item.selected = element.value;
        }
      });
    });
    const customContentNameMap: { [key: string]: string } = {
      'Custom Groups': 'Custom Percentage',
      'Custom Calculations': 'Custom Mean',
    };
    this.customContentSelection.forEach((item: any) => {
      this.customContentCheckedList?.forEach((element: any) => {
        const mappedKey = customContentNameMap[element.key] || element.key;
        if (item.name == element.key || item.name == mappedKey) {
          item.selected = element.value;
        }
      });
    });
    this.isStaticTimeFrame=false;
    this._configService.isStaticTimeFrame=false;
    this.additionalCheckBoxSelection.forEach((item: any) => {
      this.additionalCheckBoxCheckedList?.forEach((element: any) => {
        if (item.name == element.key) {
          if(item.name == 'Static Time Frame'){
            this.isStaticTimeFrame=true;
            this._configService.isStaticTimeFrame=true;
            sessionStorage.setItem('isSTF', 'true');
          }
          item.selected = element.value;
        }
      });
    });
    this.outputconfiguration.forEach((item: any) => {
      if (item.value == this.outputConfig) {
        item.selected = true;
      } else {
        item.selected = false;
      }
    });
    this.stickyDefaultSelection.forEach((item: any) => {
      if (item.value == this.stickyDefaultSelected) {
        item.selected = true;
      } else {
        item.selected = false;
      }
    });

    this.reset.forEach((item: any) => {
      if (item.value?.toLowerCase() == (this.resetSelectionFlag == true ? 'yes' : 'no')) {
        item.selected = true;
      } else {
        item.selected = false;
      }
    });

    const snapshotTypeCheckboxes = document.getElementsByClassName(
      'snapshot-type-checkbox'
    );
    for (let j = 0; j < this.snapshotData?.snapshotType_details?.length; j++) {
      for (let i = 0; i < snapshotTypeCheckboxes.length; i++) {
        let snapshotTypeCheckbox = snapshotTypeCheckboxes[
          i
        ] as HTMLInputElement;
        let chk = snapshotTypeCheckbox.querySelector(
          'input[type="checkbox"]'
        ) as HTMLInputElement;
        let label = snapshotTypeCheckbox.querySelector(
          'label'
        ) as HTMLLabelElement | null;

        if (
          label &&
          label.innerText ===
          this.snapshotData.snapshotType_details[j].snapshot_type
        ) {
          chk.checked = true;
        }
      }
    }

    ;
    this._configService.noOfWidget(this.numberOfWidget);
    this._configService.widgetDivs(this.snapshotLayout);
    ;
      this.AddAlreadySelectedAudienceSnapshot();
    this.AddAlreadySelectedEP(this.snapshotData.snapshotType_details);
    this.AddAlreadySelectedDim(this.snapshotData.snapshotType_details);

    // this.addSnapshotTab();
  }
  AddAlreadySelectedAudienceSnapshot() {
  // Check if Audience Snapshot is selected
  const hasAudienceSnapshot = this.snapshotData.snapshotType_details?.some(
    (detail: any) => detail.snapshot_type === 'Audience Snapshot'
  );

  if (hasAudienceSnapshot && this.snapshotData.audienceCohortType) {
    // Set cohort type
    this.audienceCohortType = this.snapshotData.audienceCohortType;
    this._configService.audienceCohortType = this.snapshotData.audienceCohortType;
    this.customSnapshotService.audienceCohortType = this.snapshotData.audienceCohortType;
    // Save original cohort type for change detection
    this.originalAudienceCohortType = this.snapshotData.audienceCohortType;
    
    // Enable audience comparison if cohort type is multi
    if (this.audienceCohortType === 'multi') {
      this.audienceComparisonEnabled = true;
    }
    
    // Load selected audience comparisons
    if (this.snapshotData.audienceComparsion && Array.isArray(this.snapshotData.audienceComparsion)) {
      this.selectedAudienceComparisons = this.snapshotData.audienceComparsion.map((item: any) => ({
        variable_label: item.variable_label,
        variable_code: item.data_variable_code || item.variable_code || '',
        response_code: item.response_code || '',
        config_name: item.config_name,
        is_selected: true
      }));
      this.audienceComparisonEnabled=true;
      this.audienceComparisonEnabled=true;
      
      // Sort the filtered list to show selected items first
      this.sortAudienceComparisonList();
    }
    const savedTotalSample = this.snapshotData.audienceTotalSample;
    const hasRealTotalSample =
      savedTotalSample &&
      savedTotalSample.is_selected === true &&
      !!(savedTotalSample.data_variable_code || savedTotalSample.variable_code);

    if (hasRealTotalSample) {
      this.totalSampleEnabled = true;
      this.selectedTotalSample = {
        variable_label: savedTotalSample.variable_label,
        variable_code: savedTotalSample.data_variable_code || savedTotalSample.variable_code || '',
        response_code: savedTotalSample.response_code || '',
        config_name: savedTotalSample.config_name,
        is_selected: true
      };
      this.showTotalSampleDropdown = true;
      this.sortTotalSampleList();
    } else {
      this.totalSampleEnabled = false;
      this.selectedTotalSample = null;
    }

    // Restore selected brand from snapshot data
    if (this.snapshotData.selectedBrand) {
      this.brandSelectionEnabled = true;
      this.selectedBrand = {
        variable_label: this.snapshotData.selectedBrand.variable_label,
        response_label: this.snapshotData.selectedBrand.response_label,
        metric_group: this.snapshotData.selectedBrand.metric_group || '',
        is_snapshot: this.snapshotData.selectedBrand.is_snapshot,
        is_selected: true
      };
      this.showBrandDropdown = true;
      // Sort the brand list to show selected item first
      this.sortBrandList();
    }
    
    // If audience lists are already loaded, restore selections immediately
    if (this.audienceComparision && this.audienceComparision.length > 0) {
      this.restoreAudienceSelections();
    }
    
    this.cdr.detectChanges();
  }
}

  StudytypeExpandClicks(event: Event) {
    let id = (event.target as HTMLElement).id;

    const expandIcon = document.getElementById(id) as HTMLElement;

    const expandIconSelected = document.querySelector('.expand-icon.selected');
    if (expandIconSelected && expandIconSelected.id != id) {
      expandIconSelected.classList.remove('selected');
    }

    if (expandIcon) {
      expandIcon.classList.toggle('selected');
    }

    if (id.includes('singleBrand')) {
      this.showSingleBrand = !this.showSingleBrand;
      this.showMultiBrand = false;
      this.showMultiCategory = false;
      this.showMultiMarket = false;
    } else if (id.includes('multiBrand')) {
      this.showMultiBrand = !this.showMultiBrand;
      this.showSingleBrand = false;
      this.showMultiCategory = false;
      this.showMultiMarket = false;
    } else if (id.includes('multiCategory')) {
      this.showMultiCategory = !this.showMultiCategory;
      this.showSingleBrand = false;
      this.showMultiBrand = false;
      this.showMultiMarket = false;
    } else if (id.includes('multiMarket')) {
      this.showMultiMarket = !this.showMultiMarket;
      this.showSingleBrand = false;
      this.showMultiBrand = false;
      this.showMultiCategory = false;
    }else if(id.includes('audienceSnapshot')){
      this.showAudienceSnapshot = !this.showAudienceSnapshot;
      this.showSingleBrand = false;
      this.showMultiBrand = false;
      this.showMultiCategory = false;
      this.showMultiMarket = false;
    }
  }

  ExportEntryPointsClicks(val: any, entryPoints: any, event: any) {
    entryPoints.forEach((i: any) => {
      let id = (event.target as HTMLElement).id;
      if (event.target.checked) {
        if (i == val) {
          i.is_selected = true;
          i.variable_label = id;
          this.exportEntryPoints.push(i);
        }
      } else {
        if (i == val) {
          i.is_selected = false;
          i.variable_label = id;
          this.exportEntryPoints = this.exportEntryPoints.filter(
            (j: any) => j !== i
          );
        }
      }
    });
    let a = event.target.closest('.snapshot-type-checkbox');
    let checkBox = a.querySelector('input[type="checkbox"]');
    if (!checkBox.checked) {
      checkBox.checked = true;
    }
  }

  ExportDimensionsClicks(val: any, dimensions: any, event: any) {
    dimensions.forEach((i: any) => {
      if (event.target.checked) {
        if (i == val) {
          i.is_selected = true;
          this.exportDimensions.push(i);
        }
      } else {
        if (i == val) {
          i.is_selected = false;
          this.exportDimensions = this.exportDimensions.filter(
            (j: any) => j !== i
          );
        }
      }
    });
    let a = event.target.closest('.snapshot-type-checkbox');
    let checkBox = a.querySelector('input[type="checkbox"]');
    if (!checkBox.checked) {
      checkBox.checked = true;
    }
  }

  GetSelectedEntryPoint(snapshot_type: any) {
    let ep: any[] = [];
    switch (snapshot_type) {
      case 'Single Brand': {
        ep = this.entryPointsSB.filter(
          (entryPoint: any) => entryPoint.is_selected
        );
        break;
      }
      case 'Multiple Brands': {
        ep = this.entryPointsMB.filter(
          (entryPoint: any) => entryPoint.is_selected
        );
        break;
      }
      case 'Multiple Categories': {
        ep = this.entryPointsMC.filter(
          (entryPoint: any) => entryPoint.is_selected
        );
        break;
      }
      case 'Multiple Markets': {
        ep = this.entryPointsMM.filter(
          (entryPoint: any) => entryPoint.is_selected
        );
        break;
      }
      case 'Audience Snapshot': {
        ep = this.entryPointsAS.filter(
          (entryPoint: any) => entryPoint.is_selected
        );
        break;
      }
    }
    return ep;
  }

  GetSelectedDimension(snapshot_type: any) {
    let d: any[] = [];
    switch (snapshot_type) {
      case 'Single Brand': {
        d = this.dimensionsSB.filter((dimension: any) => dimension.is_selected);
        break;
      }
      case 'Multiple Brands': {
        d = this.dimensionsMB.filter((dimension: any) => dimension.is_selected);
        break;
      }
      case 'Multiple Categories': {
        d = this.dimensionsMC.filter((dimension: any) => dimension.is_selected);
        break;
      }
      case 'Multiple Markets': {
        d = this.dimensionsMM.filter((dimension: any) => dimension.is_selected);
        break;
      }
      case 'Audience Snapshot': {
        d = this.dimensionsAS.filter((dimension: any) => dimension.is_selected);
        break;
      }
    }
    return d;
  }

  PopulateEntryPointsAndDimensions() {

    this.entryPointsSB = this.snapshotDetails.entryPointsDetails.map(
      (entryPoint: any, index: number) => {

        return {
          variable_label: entryPoint.label,
          is_selected: false,
          variable_code: entryPoint.code,
        };
      }
    );

    this.dimensionsSB = this.snapshotDetails.dimensionsDetails.map(
      (dimension: any, index: number) => {
        return {
          variable_label: dimension.label,
          is_selected: false,
          variable_code: dimension.code,
        };
      }
    );

    this.entryPointsMB = this.snapshotDetails.entryPointsDetails.map(
      (entryPoint: any, index: number) => {
        return {
          variable_label: entryPoint.label,
          is_selected: false,
          variable_code: entryPoint.code,
        };
      }
    );

    this.dimensionsMB = this.snapshotDetails.dimensionsDetails.map(
      (dimension: any, index: number) => {
        return {
          variable_label: dimension.label,
          is_selected: false,
          variable_code: dimension.code,
        };
      }
    );
    this.entryPointsMC = this.snapshotDetails.entryPointsDetails.map(
      (entryPoint: any, index: number) => {
        return {
          variable_label: entryPoint.label,
          is_selected: false,
          variable_code: entryPoint.code,
        };
      }
    );

    this.dimensionsMC = this.snapshotDetails.dimensionsDetails.map(
      (dimension: any, index: number) => {
        return {
          variable_label: dimension.label,
          is_selected: false,
          variable_code: dimension.code,
        };
      }
    );
    this.entryPointsMM = this.snapshotDetails.entryPointsDetails.map(
      (entryPoint: any, index: number) => {
        return {
          variable_label: entryPoint.label,
          is_selected: false,
          variable_code: entryPoint.code,
        };
      }
    );

      this.dimensionsMM = this.snapshotDetails.dimensionsDetails.map(
        (dimension: any, index: number) => {
          return {
            variable_label: dimension.label,
            is_selected: false,
            variable_code: dimension.code,
          };
        }
      );
    this.entryPointsAS = this.snapshotDetails.entryPointsDetails.map(
      (entryPoint: any, index: number) => {

        return {
          variable_label: entryPoint.label,
          is_selected: false,
          variable_code: entryPoint.code,
        };
      }
    );
   this.dimensionsAS = this.snapshotDetails.dimensionsDetails.map(
        (dimension: any, index: number) => {
          return {
            variable_label: dimension.label,
            is_selected: false,
            variable_code: dimension.code,
          };
        }
      );
  }

  AddAlreadySelectedEP(selectedEPs: any) {
    for (const selectedEP of selectedEPs) {
      const entryPoints = this.getEntryPointsBySnapshotType(
        selectedEP.snapshot_type
      );
      for (const entryPoint of selectedEP.entry_point) {
        const selectedVariableLabel = entryPoint.variable_label;
        const matchingEntryPoint = entryPoints.find(
          (ep) => ep.variable_label === selectedVariableLabel
        );
        if (matchingEntryPoint) {
          matchingEntryPoint.is_selected = entryPoint.is_selected;
        }
      }
    }
  }

  getEntryPointsBySnapshotType(snapshotType: string) {
    switch (snapshotType) {
      case 'Single Brand':
        return this.entryPointsSB;
      case 'Multiple Brands':
        return this.entryPointsMB;
      case 'Multiple Categories':
        return this.entryPointsMC;
      case 'Multiple Markets':
        return this.entryPointsMM;
      case 'Audience Snapshot':
        return this.entryPointsAS;
      default:
        return [];
    }
  }

  ClearAlreadySelectedEntryPoints() {
    this.entryPointsSB.forEach((entryPoint: any) => {
      entryPoint.is_selected = false;
    });

    this.entryPointsMB.forEach((entryPoint: any) => {
      entryPoint.is_selected = false;
    });

    this.entryPointsMC.forEach((entryPoint: any) => {
      entryPoint.is_selected = false;
    });

    this.entryPointsMM.forEach((entryPoint: any) => {
      entryPoint.is_selected = false;
    });

      this.entryPointsAS.forEach((entryPoint: any) => {
      entryPoint.is_selected = false;
    });
  }

  ClearAlreadySelectedDimensions() {
    this.dimensionsSB.forEach((dimension: any) => {
      dimension.is_selected = false;
    });

    this.dimensionsMB.forEach((dimension: any) => {
      dimension.is_selected = false;
    });

    this.dimensionsMC.forEach((dimension: any) => {
      dimension.is_selected = false;
    });

    this.dimensionsMM.forEach((dimension: any) => {
      dimension.is_selected = false;
    });

     this.dimensionsAS.forEach((dimension: any) => {
      dimension.is_selected = false;
    });
  }

  AddAlreadySelectedDim(selectedDims: any) {
    for (const selectedDim of selectedDims) {
      const dimensions = this.getDimensionsBySnapshotType(
        selectedDim.snapshot_type
      );
      for (const dimension of selectedDim.dimension) {
        const selectedVariableLabel = dimension.variable_label;
        const matchingDimension = dimensions.find(
          (dim) => dim.variable_label === selectedVariableLabel
        );
        if (matchingDimension) {
          matchingDimension.is_selected = dimension.is_selected;
        }
      }
    }
  }

  getDimensionsBySnapshotType(snapshotType: string) {
    switch (snapshotType) {
      case 'Single Brand':
        return this.dimensionsSB;
      case 'Multiple Brands':
        return this.dimensionsMB;
      case 'Multiple Categories':
        return this.dimensionsMC;
      case 'Multiple Markets':
        return this.dimensionsMM;
      case 'Audience Snapshot':
        return this.dimensionsAS;
      default:
        return [];
    }
  }

  CheckSnapshotNameDuplicate(snapshotName: string) {


    if (this._configService.clientAllSnapshotNames.includes(snapshotName)) {
      this.popUpMessage =
        'SNAPSHOT NAME already exists for this client. Please enter a different name.';
      return false;
    } else {
      return true;
    }
  }

  uncheckOnError(item: any, event: any) {
    if(item.name == "Static Time Frame") {
      this.isStaticTimeFrame = false;
      this._configService.isStaticTimeFrame = false;
    }
    else{
      this.isPreviousPeriosOrYear = false;
    }
    event.target.checked = false;
  }
  isAudienceComparisonChecked(): boolean {
    // handles undefined/null and empty array cases safely
    return Array.isArray(this.selectedAudienceComparisons) && this.selectedAudienceComparisons.length > 0;
}

  ngOnDestroy(): void {
    // Unsubscribe to prevent memory leaks and unnecessary reloads
    this.subscriptions.unsubscribe();

    // Restore the previously-saved --loader-gif value so other parts of the app are unaffected
    try {
      if (this._savedLoaderGifVar && this._savedLoaderGifVar.trim() !== '') {
        document.documentElement.style.setProperty('--loader-gif', this._savedLoaderGifVar);
      } else {
        document.documentElement.style.removeProperty('--loader-gif');
      }
    } catch (e) {}
  }
}
